<template>
  <div>
    <div class="personalInfo">

      <div class="card-right">
        <!-- 订单查询 -->
        <!-- 上传文件 -->
        <div class="info bill" v-if="checked === 1">
          <div class="card">
            <div class="card-top">
              <span></span>
              <h3>订单查询</h3>
            </div>
            <!--筛选条件-->
            <div class="screen">
              <el-row :gutter="15">
                <el-col :span="30" class="colls"  >

                  <el-date-picker
                    format="yyyy-MM-dd"
                    placeholder="订单开始日期"
                    type="date"
                    v-model="starttime"
                    value-format="yyyy-MM-dd"
                    style="width: 150px;"
                    @input="query"
                  >
                  </el-date-picker>
                  <div class="kuoz">-</div>
                  <el-date-picker
                    format="yyyy-MM-dd"
                    placeholder="订单结束日期"
                    type="date"
                    v-model="endtime"
                    value-format="yyyy-MM-dd"
                    style="width: 150px;"
                    @input="query"
                  >
                  </el-date-picker>

                  <el-input
                      placeholder="请输入订单号"
                      v-model="orderId"
                      style="width: 150px;margin-left: 3px"
                      @keyup.enter.native="query"
                      @input="query"
                      ></el-input>
                  <el-input
                      placeholder="请输入产品名称"
                      v-model="orderName"
                      style="width: 150px;margin-left: 3px"
                      @keyup.enter.native="query"
                      @input="query"
                  ></el-input>


                  <el-input
                      placeholder="请选择客户"
                      v-model="orderuserName"
                      @focus="changeMember"
                      v-if="userType !==0"
                      style="width: 150px;margin-left: 3px"
                  ></el-input>
                  <el-select
                      filterable
                      placeholder="请选择客服"
                      v-model="customerID"
                      style="width: 150px;margin-left: 3px"
                      clearable
                      @change="query"
                      v-if="userType == 1"
                  >
                    <el-option
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        v-for="item in options"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                      placeholder="请选择订单审核状态"
                      v-model="fileStatus"
                      style="width: 100px;
                      margin-left: 3px;"
                      clearable
                      @change="query"
                  >
                    <el-option
                        label="待审核"
                        value="0"
                    />
                    <el-option
                        label="审核通过"
                        value="1"
                    />
                    <el-option
                        label="驳回"
                        value="2"
                    />
                    <el-option
                        label="取消"
                        value="99"
                    />
                  </el-select>
                 <p class="moneyTotal"  >
                 <p  style="margin-left: 20px;"  v-if="userType === 0 && showFlag">
                      合计金额:<span style="color: #ff0000">{{
                        allTotalMoney
                      }}</span>
                    </p>
                  </p>
                  <el-button @click="query" class="btn" type="primary"
                  >查询
                  </el-button>
                  <el-button  @click="goToPay"  v-if="userType == 0"  class="btn" type="primary"
                  >去充值
                  </el-button>
                  <el-button  @click="onlinePay"  v-if="userType == 0"  class="btn" type="primary"
                  >在线支付
                  </el-button>
                  <el-button  @click="exportData"   class="btn" type="primary"
                  >导出
                  </el-button>
                </el-col>
              </el-row>
            </div>
        <div class="tables">
              <el-table
                  :cell-style="tableRowStyle"
                  :data="tableData"
                  border
                  ref="tables"
                  style="width: 100%;margin-top: 10px;"
                  @select="moreSelect"
                  @selection-change="changeSelect"
               >
                <el-table-column
                    v-if="userType == 0"
                    type="selection"
                    width="50"
                    align="center"
                    :selectable="selectEnable"
                    header-align="center"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    v-if="userType >= 1"
                    label="客户"
                    width="150"
                    prop="customername"
                >
                  <template slot-scope="scope">
                    <div    :title="scope.row.contacttel" >{{  scope.row.customername }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="left"
                    label="订单号"
                    width="130"
                    prop="id"
                />
                <el-table-column
                    header-align="center"
                    align="center"
                    label="下单时间"
                    width="150"
                    prop="ordertime"
                />
                <el-table-column
                    header-align="center"
                    align="center"
                    label="审核时间"
                    width="150"
                    prop="approvetime"
                />
                <el-table-column
                    header-align="center"
                    align="center"
                    label="类型"
                    width="120"
                    prop="productname"
                />
                <el-table-column
                    header-align="center"
                    align="left"
                    label="产品名称"
                    width="200"
                    prop="ordername"
                />
                <el-table-column
                    header-align="center"
                    align="left"
                    label="详情"
                    width="230"
                    :width="userType >= 1 ? '200': '230'"
                    prop="quoteDesc">
                <template slot-scope="scope">
                    <div   :title="scope.row.quoteDesc">{{  scope.row.quoteDesc }}{{  scope.row.custRemark }}</div>
                  <i
                      v-if="userType >= 1 && scope.row.deleted == 0 "
                      class="el-icon-edit type"
                      @click="editDetail(scope.row)"
                  ></i>
                 </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    v-if="userType >= 1"
                    label="系统报价"
                    width="100"
                    prop="firstFee"
                 >
                  <template slot-scope="scope">
                    <span @click="showHis(scope.row)" style="cursor: pointer;">{{ Number(scope.row.firstFee).toFixed(2)  ==0?'--':Number(scope.row.firstFee).toFixed(2)}}</span>

                 </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    v-if="userType >= 1"
                    align="center"
                    label="成交金额"
                    width="100"
                    prop="discountfee"
                >
                  <template slot-scope="scope">
                    <span v-if="Number(scope.row.firstFee).toFixed(2) !=Number(scope.row.discountfee).toFixed(2) " style="color: red;">{{  Number(scope.row.discountfee).toFixed(2) ==0?'--':Number(scope.row.discountfee).toFixed(2) }} </span>
                    <span v-else  >{{  Number(scope.row.discountfee).toFixed(2) }} </span>
                    <i
                        v-if="scope.row.payStruts === 3 &&  scope.row.deleted == 0 && (userType ==1  || (scope.row.fileStatus !=='1' && userType == 2)) "
                        class="el-icon-edit type"
                        @click="editMoney(scope.row)"
                    ></i>
                  </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    label="金额"
                    width="100"
                    prop="discountfee"
                    v-if="userType == 0"
                >
                  <template slot-scope="scope">
                    <span   style="cursor: pointer;">{{ Number(scope.row.discountfee).toFixed(2)==0?'--':Number(scope.row.discountfee).toFixed(2) }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                    header-align="center"
                    align="center"
                    label="支付状态"
                    width="100"
                    prop="payStruts"
                 >
                  <template slot-scope="scope">
                    <span   style="cursor: pointer;">{{  scope.row.payStruts === 3?'未支付': scope.row.payStruts === 5?'已支付':''}}</span>
                  </template>
                </el-table-column>
                <el-table-column header-align="center"   :width="userType >= 1 ? '80': '215'"   align="center" label="操作">

                  <template slot-scope="scope">
                    <div class="top">
                      <span v-if="scope.row.fileStatus ==='0' && scope.row.deleted == 0&& scope.row.refunded  ==0 "   style="font-size: 18px;color: red;">待审核</span>
                      <span v-if="scope.row.fileStatus ==='1'  && scope.row.deleted == 0&& scope.row.refunded  == 0"   style="font-size: 18px;color: #409eff;">审核通过</span>
                      <span v-if="scope.row.fileStatus ==='2'  && scope.row.deleted == 0&& scope.row.refunded == 0"   style="font-size: 18px;color: orange;">驳回</span>
                      <span  style="font-size: 18px;">{{ scope.row.deleted == 1 || scope.row.refunded == 1?  "已取消":'' }}</span>
                   </div>
                    <div class="box types">
                      <el-link
                          @click="track(scope.row)"
                          size="small"
                          type="primary"
                          v-if="scope.row.deleted == 0&& scope.row.refunded == 0 "
                      ><i ></i>进度追踪
                      </el-link>
                      <el-link  v-if="scope.row.status === '6' && scope.row.deleted == 0  && scope.row.refunded ==0 " @click="logistics(scope.row)"  type="primary"  >物流信息</el-link>
                      <el-link   v-if="fileConfig && scope.row.deleted == 0 && scope.row.refunded == 0  && (scope.row.fileStatus ==='0' ||  scope.row.fileStatus ==='2')" @click="upLoadFile(scope.row)" type="primary"
                      >{{
                          scope.row.uploadEntry > 0
                              ? "查看上传文件"
                              : "待上传文件"
                        }}
                      </el-link>
                      <div   style="color:red;margin-left: 20px;cursor: pointer;"  :title="scope.row.reviewOpinions" v-if=" userType == 0 &&  scope.row.fileStatus ==='2' && scope.row.refunded ==0"  >文件错误原因</div>


                      <el-link
                          v-if="fileConfig && scope.row.deleted == 0 && scope.row.refunded ==0  &&  userType >= 1   && (scope.row.fileStatus === '0' || scope.row.fileStatus === '2')"
                          @click="fileApprove(scope.row)"
                          type="primary"
                          style="color: red;"
                      > 文件审核
                      </el-link>

<!--                      <el-link-->
<!--                          v-if="scope.row.deleted == 0&& scope.row.refunded == 0 "-->
<!--                          @click="details(scope.row)"-->
<!--                          :underline="false"-->
<!--                          type="primary"-->
<!--                      >订单详情-->
<!--                      </el-link>-->
                      <el-link
                          v-if = "userType >= 1 && scope.row.deleted == 0&& scope.row.refunded == 0"
                          @click="feeDetails(scope.row)"
                          type="primary"
                      >报价明细
                      </el-link>
                      <el-link
                          @click="complaint(scope.row)"
                          v-if="scope.row.deleted == 0 && userType == 0 && scope.row.refunded ==0"
                          type="primary"
                      >{{ scope.row.complaintEntry > 0 ? "已投诉" : "投诉" }}
                      </el-link>
                      <el-link
                          v-show="(scope.row.deleted == 0 && userType == 1 && scope.row.refunded == 0) || (scope.row.deleted == 0 && scope.row.fileStatus !=='1' && scope.row.refunded == 0)"
                          @click="delleteOrder(scope.row)"
                          type="primary"
                      >
                        取消订单
                      </el-link>
                      <el-link
                          v-show="scope.row.deleted == 0 && userType !==0 && scope.row.refunded == 0  && scope.row.payStruts !== 5"
                          @click="onlinePayAdmin(scope.row)"
                          type="primary"
                      >
                        在线支付
                      </el-link>

                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>


            <!-- 上传文件弹出层 -->
            <el-dialog
              :visible.sync="dialogVisible"
              title="上传并关联文件"
              width="55%"
              class="file"
            >
              <div STYLE=" text-align: center;">
                <div class="top">
                  <p>订单编号：{{ orderInfo.id }}</p>

                </div>
                <div class="tableList" v-if="fileData.length > 0">
                  <el-table :data="fileData" border style="width: 100%">
                    <el-table-column
                      align="center"
                      header-align="center"
                      label="上传时间"
                      prop="createTime"
                    ></el-table-column>
                    <el-table-column
                      align="center"
                      header-align="center"
                      label="文件名"
                      prop="orderFileName"
                    ></el-table-column>
                    <el-table-column
                      align="center"
                      header-align="center"
                      label="状态"
                    >
                      <template slot-scope="scope">
                        <span
                          :class="
                            scope.row.orderFileStruts == '1'
                              ? 'success'
                              : 'error'
                          "
                          >{{
                            scope.row.orderFileStruts == "1"
                              ? "已上传"
                              : "上传失败"
                          }}</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      header-align="center"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button
                          @click="delFile(scope.row)"
                          size="mini"
                          type="danger"
                          v-if="userType == 0"
                          >删除
                        </el-button>
                        <el-button
                          @click="browse(scope.row)"
                          size="mini"
                          type="warning"
                          class="browse"
                        >
                          <a class="liulan" :href="BrowseUrl" target="_blank"
                            >浏览</a
                          >
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>

                <div class="tableList" v-else>
                  <el-table :data="fileData" border style="width: 100%">
                    <el-table-column
                      align="center"
                      header-align="center"
                      label="上传时间"
                      prop="createTime"
                    ></el-table-column>
                    <el-table-column
                      align="center"
                      header-align="center"
                      label="文件名"
                      prop="orderFileName"
                    ></el-table-column>
                    <el-table-column
                      align="center"
                      header-align="center"
                      label="状态"
                    >
                      <template slot-scope="scope">
                        <span
                          :class="
                            scope.row.orderFileStruts == '1'
                              ? 'success'
                              : 'error'
                          "
                          >{{
                            scope.row.orderFileStruts == "1"
                              ? "已上传"
                              : "上传失败"
                          }}</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      header-align="center"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button
                          v-if="userType == 0"
                          @click="delFile(scope.row,'1')"
                          size="mini"
                          type="danger"
                          >删除
                        </el-button>
                        <el-button
                          @click="browse(scope.row)"
                          size="mini"
                          type="warning"
                          class="browse"
                        >
                          <a class="liulan" href="" target="_blank">浏览</a>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div      v-if="userType == 0" class="noTable">暂无文件,点击下方按钮上传文件吧！</div>
                </div>


                <el-upload
                  :auto-upload="false"
                  :file-list="fileList"
                  :on-preview="handlePreview"
                  :on-change="handChange"
                  :http-request="customUpload"
                  :on-success="onSuccess"
                  :on-progress="onProgress"
                  :before-remove="befRemove"
                  action="#"
                  class="upload-demo"
                  id="upload-demo"
                  ref="upload"
                  v-if="userType ==0"
                >
                  <el-button size="small" slot="trigger" type="primary"
                    >选取文件
                  </el-button>
                  <el-button
                    @click="submitUpload"
                    size="small"
                    style="margin-left: 10px"
                    type="success"
                    >确认替换
                  </el-button>
                </el-upload>
              </div>
              <!--<span class="dialog-footer" slot="footer">-->
              <!--  <el-button @click="dialogVisible = false">取 消</el-button>-->
              <!--  <el-button @click="dialogVisible = false" type="primary">确 定</el-button>-->
              <!--</span>-->
            </el-dialog>
            <!--进度追踪弹出层-->
            <el-dialog :visible.sync="speed" title="订单进度追踪" width="30%">
              <el-timeline :reverse="true" v-if="activities.length > 0">
                <el-timeline-item
                  v-for="(activity, index) in activities"
                  :key="index"
                  :color="activity.color"
                  :timestamp="activity.opTime"
                >
                  {{ activity.opProject }}
                </el-timeline-item>
              </el-timeline>
              <p v-else>当前订单流程暂未更新，请谅解...</p>
              <span class="dialog-footer" slot="footer">
                <el-button @click="speed = false">取 消</el-button>
                <el-button @click="speed = false" type="primary"
                  >确 定</el-button
                >
              </span>
            </el-dialog>
            <!-- 发票弹出层 -->
            <el-dialog :visible.sync="billing" title="开票信息" width="30%">
              <div class="content">
                <div class="orderInfo">
                  <p>
                    订单金额：<span style="color: #ff0000">{{
                      discountfeeTotal
                    }}</span>
                  </p>
                </div>
                <div class="fapiao">
                  <p>
                    发票类型：<span>{{
                      billdInfo.increaseTicketType
                    }}</span>
                  </p>
                  <p>
                    开票类型：<span>{{
                      billdInfo.extendColumn1 === "1" ? "个人" : "单位"
                    }}</span>
                  </p>
                  <p>收票人姓名：{{ billdInfo.recipientSName }}</p>
                  <p>收票人电话：{{ billdInfo.recipientSPhone }}</p>
                  <p v-if="billdInfo.extendColumn1 === '1'">
                    收票抬头：{{ billdInfo.increaseTicketTitle }}
                  </p>
                  <div class="danwei" v-if="billdInfo.extendColumn1 === '2'">
                    <p>收票单位：{{ billdInfo.unitName }}</p>
                    <p>发票税号：{{ billdInfo.increaseTicketNumber }}</p>
                    <p>注册地址：{{ billdInfo.increaseTicketAdress }}</p>
                    <p>注册电话：{{ billdInfo.increaseTicketPhone }}</p>
                    <p>开户银行：{{ billdInfo.increaseTicketBank }}</p>
                    <p>银行账号：{{ billdInfo.increaseTicketBankNumber }}</p>
                  </div>
                  <p>
                    收票地址：{{ billdInfo.recipientSProvinceZh }}
                    {{ billdInfo.recipientSCityZh }}
                    {{ billdInfo.recipientSAreaZh }}
                    {{ billdInfo.recipientSAdress }}
                  </p>
                </div>
              </div>
              <span class="dialog-footer" slot="footer">
                <el-button @click="billing = false">取 消</el-button>
                <el-button @click="sureBill" type="primary">确 定</el-button>
              </span>
            </el-dialog>
            <!-- 支付弹出层 -->
            <el-dialog
              title="订单支付"
              :visible.sync="payPop"
              width="50%"
              @close="closeDlg"
            >
              <div class="payContent">
                <div class="orderInfo">
                  <p v-if="userType !== 0">
                    客户名称：<span style="color: #058af2">{{
                      customerName
                    }}</span>
                  </p>
                  <p>
                    产品名称：<span style="color: #058af2">{{
                      orderInfo.ordername
                    }}</span>
                  </p>
                  <p>
                    订单金额：<span style="color: #ff0000">{{
                      orderInfo.discountfee
                    }}</span>
                  </p>
                  <p>
                    订单编号：<span>{{ orderInfo.id }}</span>
                  </p>
                  <p v-if="radio !== '3'">
                    实付金额：<span style="color: #ff0000">{{
                      orderInfo.discountfee | numbers
                    }}</span>
                  </p>
                  <p v-if="radio === '3'">
                    线下实付金额：<span style="color: #ff0000">{{
                      orderInfo.discountfee | numbers
                    }}</span>
                  </p>
                </div>
                <div class="feetype">
                  <span>付款方式：</span>
<!--                  <el-radio-->
<!--                    v-model="radio"-->
<!--                    label="1"-->
<!--                    :disabled="orderInfo.payStruts === 4"-->
<!--                    >首付30%-->
<!--                  </el-radio>-->
                  <el-radio v-model="radio" label="2">在线支付</el-radio>
                  <el-radio  v-model="radio" label="3"
                    >对公转账</el-radio
                  >
                </div>
                <div class="top">
                  <el-checkbox-group
                    v-model="checkList"
                    class="check-group"
                    @change="checkGroup"
                  >
                    <el-checkbox label="1" :disabled="disabled1">
                      <span v-if="userType !== 0"
                        >{{ customerName }}的钱包余额：</span
                      >
                      <span v-else>钱包余额:</span>
                      <span style="color: #ff0000">{{ wallet }}</span
                      >元 (选择抵扣)
                    </el-checkbox>
                    <el-checkbox label="2" :disabled="disabled2"
                      >扫码支付
                    </el-checkbox>

                      <el-checkbox label="3" :disabled="disabled3"
                        >信用付(<span style="color: #ff0000;display: none;">{{ credit }}</span
                        >元 额度)
                      </el-checkbox>
                  </el-checkbox-group>


                  <el-alert
                      v-if="radio === '3'"
                      title="请往下面的对公账号转入订单金额后,再电话联系我们"
                      style="margin-top: 20px;"
                       type="warning"
                      :closable="false"
                    >
                    <div style="font-size: 18px;"   v-html="mallBankInfo">
                    </div>
                  </el-alert>
                </div>
                <div class="ipt" v-show="changeType === '1'">
                  <span>支付密码：</span>
                  <el-input
                    @input="wacthChange"
                    @blur="blurs($event)"
                    @focus="newPwdFocus($event)"
                    class="inputs"
                    v-model="input"
                    placeholder="请输入支付密码"
                    :type="
                      (newPwdReadOnly && input) || input ? 'password' : 'text'
                    "
                    :readonly="newPwdReadOnly"
                    auto-complete="new-password"
                    name="person.user.new_password"
                    ref="inputPs"
                  ></el-input>
                </div>
                <div class="payTypes" v-show="showPayType">
                  <div class="pingtai">
                    <ul>
                      <li>
                        <div class="wx" @click="bills('wx')"></div>
                      </li>
                      <li>
                        <div class="zfb" @click="bills('zfb')"></div>
                      </li>
                    </ul>
                  </div>
                  <div class="imgs" v-show="img !== ''">
                    <vue-qr :text="img" :size="200"></vue-qr>
                  </div>
                  <p v-if="showText === 1">请用微信支付</p>
                  <p v-if="showText === 2">请用支付宝支付</p>
                </div>
                <div class="successBtn" v-show="showPsBtn">
                  <!-- <el-button type="primary" @click="surePay"
                                      >是否支付成功
                                    </el-button>
                                    <i class="el-icon-warning" style="color: #00c800"
                                      >如果支付成功请点击此按钮</i
                                    > -->
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="clearPayData">取 消</el-button>
                <el-button
                  :loading="payLoading"
                  type="primary"
                  @click="comitPay"
                  :disabled="showSuer"
                  >确 定</el-button
                >
              </span>
            </el-dialog>
            <el-dialog
                title="订单支付"
                :visible.sync="onlinePayPop"
                width="50%"
                @close="closeDlg"
            >
              <div class="payContent">
                <div class="orderInfo">

                  <p>
                     <span style="color: #ff0000; display: flex; font-size: 40px; justify-content: center;">¥{{
                      Number(this.orderInfo.discountfee).toFixed(2)
                    }}</span>
                  </p>

                </div>



                <div class="payTypes" >
                  <div class="pingtai">
                    <ul>
                      <li>
                        <div class="wx" @click="onlineBills('wx')"></div>
                      </li>
                      <li>
                        <div class="zfb" @click="onlineBills('zfb')"></div>
                      </li>
                    </ul>
                  </div>
                  <div class="imgs" v-show="img !== ''">
                    <vue-qr :text="img" :size="200"></vue-qr>
                  </div>
                  <p v-if="showText === 1">请用微信支付</p>
                  <p v-if="showText === 2">请用支付宝支付</p>
                </div>

              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="clearOnlinePayData">取 消</el-button>
                <el-button
                    :loading="payLoading"
                    type="primary"
                    @click="comitOnlinePay"
                    :disabled="showSuer"
                >我已完成支付</el-button
                >
              </span>
            </el-dialog>
            <el-dialog
                title="订单批量支付"
                :visible.sync="batchPayPop"
                width="50%"
                @close="closeDlg"
            >
              <div class="payContent">
                <div class="orderInfo">

                  <p>
                    订单总金额：<span style="color: #ff0000">{{
                      Number(this.orderInfo.discountfee).toFixed(2)
                    }}</span>
                  </p>

                </div>
                <div class="feetype">
                  <span>付款方式：</span>
                  <el-radio v-model="radio" label="2">在线支付</el-radio>
                </div>
                <div class="top">
                  <el-checkbox-group
                      v-model="checkList"
                      class="check-group"
                      @change="checkGroup"
                  >
                    <el-checkbox label="1" :disabled="disabled1">
                      <span v-if="userType !== 0">{{ customerName }}的钱包余额：</span>
                      <span v-else>钱包余额:</span><span style="color: #ff0000">{{ wallet }}</span>元 (选择抵扣)
                    </el-checkbox>
                    <el-checkbox label="2" :disabled="disabled2">扫码支付
                    </el-checkbox>
                    <el-checkbox label="3" :disabled="disabled3">信用付：<span style="color: #ff0000;display: none;">{{ credit }}</span>元 额度
                    </el-checkbox>

                  </el-checkbox-group>


                  <el-alert
                      v-if="radio === '3'"
                      title="请往下面的对公账号转入订单金额后,再电话联系我们"
                      style="margin-top: 20px;"
                      type="warning"
                      :closable="false"
                  >
                    <div style="font-size: 18px;"   v-html="mallBankInfo">
                    </div>
                  </el-alert>
                </div>
                <div class="ipt" v-show="changeType === '1'">
                  <span>支付密码：</span>
                  <el-input
                      @input="wacthChange"
                      @blur="blurs($event)"
                      @focus="newPwdFocus($event)"
                      class="inputs"
                      v-model="input"
                      placeholder="请输入支付密码"
                      :type="
                      (newPwdReadOnly && input) || input ? 'password' : 'text'
                    "
                      :readonly="newPwdReadOnly"
                      auto-complete="new-password"
                      name="person.user.new_password"
                      ref="inputPs"
                  ></el-input>
                </div>
                <div class="payTypes" v-show="showPayType">
                  <div class="pingtai">
                    <ul>
                      <li>
                        <div class="wx" @click="billsBatch('wx')"></div>
                      </li>
                      <li>
                        <div class="zfb" @click="billsBatch('zfb')"></div>
                      </li>
                    </ul>
                  </div>
                  <div class="imgs" v-show="img !== ''">
                    <vue-qr :text="img" :size="200"></vue-qr>
                  </div>
                  <p v-if="showText === 1">请用微信支付</p>
                  <p v-if="showText === 2">请用支付宝支付</p>
                </div>
                <div class="successBtn" v-show="showPsBtn">
                  <!-- <el-button type="primary" @click="surePay"
                                      >是否支付成功
                                    </el-button>
                                    <i class="el-icon-warning" style="color: #00c800"
                                      >如果支付成功请点击此按钮</i
                                    > -->
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="clearBatchPayData">取 消</el-button>
                <el-button
                    :loading="payLoading"
                    type="primary"
                    @click="comitBatchPay"
                    :disabled="showSuer"
                >确 定</el-button
                >
              </span>
            </el-dialog>
            <!-- 订单详情 -->
            <el-dialog
              :visible.sync="detail"
              class="detail"
              :title="title"
              width="55%"
            >
              <order-details
                ref="orderDetails"
                v-bind:orderId="orderInfo.id"
                :key="timer"
              ></order-details>
            </el-dialog>
            <!-- 报价明细 -->
            <el-dialog
                :visible.sync="feedetail"
                class="detail"
                :title="title"
                width="60%"
            >
              <fee-details
                  ref="feeDetails"
                  v-bind:orderId="orderInfo.id"
                  v-bind:userfatherid="orderInfo.userfatherid"
                  v-bind:orderfee="orderInfo.orderfee"
                  :key="timer"
              ></fee-details>
            </el-dialog>
            <!-- 投诉 -->
            <el-dialog
              :visible.sync="complaints"
              class="complaints"
              title="订单投诉"
              width="55%"
            >
              <table>
                <tr>
                  <th>订单号</th>
                  <th>印件名称</th>
                  <th>产品数量</th>
                  <th>订单金额</th>
                </tr>
                <tr>
                  <td>{{ complaintsList.id }}</td>
                  <td>{{ complaintsList.ordername }}</td>
                  <td>{{ complaintsList.quantitydemanded }}</td>
                  <td>{{ complaintsList.discountfee }}</td>
                </tr>
              </table>

              <!--投诉分类-->
              <el-form
                ref="form"
                :rules="rule"
                :model="form"
                label-width="100px"
                class="fwb"
              >
                <el-form-item label="投诉分类：" prop="types">
                  <el-checkbox-group
                    v-model="form.types"
                    @change="CheckedChange"
                  >
                    <el-checkbox
                      v-for="item in ComplaintClassification"
                      :label="item"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <!--投诉内容-->
                <!--                <el-form ref="rule" :model="form" label-width="100px" class="fwb">-->
                <el-form-item label="投诉内容：" prop="text">
                  <editor
                    v-model.trim="form.text"
                    @change="change"
                    :info="form.text"
                  ></editor>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitForm('form')"
                    >立即投诉
                  </el-button>
                  <el-button @click="resetForm('form')">重置</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
            <!--分页-->
            <div class="pages">
              <el-pagination
                :current-page="currentPage"
                :page-size="pageSize"
                :page-sizes="[5, 10, 20, 30, 50 ,100,150,200]"
                :total="total"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                layout="total, sizes, prev, pager, next, jumper"
              >
              </el-pagination>
              <!-- <el-button
                @click="applyInvoice"
                class="btn"
                size="mini"
                type="primary"
                >发票申请
              </el-button> -->
            </div>
            <!-- 编辑订单金额 -->
            <el-dialog title="修改订单价格" :visible.sync="editMoneys" width="30%">
              <el-input v-model="money" placeholder="请输入需要修改的金额"></el-input>
              <span slot="footer" class="dialog-footer">
          <el-button @click="editMoneys = false">取 消</el-button>
          <el-button type="primary" @click="sureEdit">确 定</el-button>
        </span>
            </el-dialog>

            <el-dialog title="修改订单价格" :visible.sync="hisdialogVisible" width="35%">
              <el-table :data="hisData" border style="width: 100%">
                <el-table-column label="修改时间" prop="createTime" width="170" header-align="center"/>
                <el-table-column label="修改前金额" prop="amountBeforeChange" width="150" header-align="center"/>
                <el-table-column label="修改后金额" prop="amountAfterChange" width="150" header-align="center"/>
                <el-table-column label="修改人"  prop="operatorName" width="150" header-align="center"/>
              </el-table>
              <span slot="footer" class="dialog-footer">
          <el-button @click="hisdialogVisible = false">取 消</el-button>
        </span>
            </el-dialog>
            <el-dialog title="修改订单信息" :visible.sync="editQuoteDesc" width="35%">
              订单详情:<el-input type="textarea" v-model="quoteDesc" ></el-input>

              备注:<el-input type="textarea" v-model="custRemark" ></el-input>
              <span slot="footer" class="dialog-footer">
               <el-button @click="editQuoteDesc = false">取 消</el-button>
                <el-button type="primary" @click="quoteDescEdit">确 定</el-button>
             </span>
            </el-dialog>
          </div>
        </div>
        <!-- 开票记录 -->
        <div class="invoices" v-if="checked === 2">
          <!-- 开票列表 -->
          <div class="card">
            <div class="card-top">
              <span></span>
              <h3>开票记录表</h3>
            </div>
            <div class="query">
              <el-input
                class="input"
                v-model="querys"
                placeholder="请输入订单号"
              ></el-input>
              <el-select v-model="value2" placeholder="请选择" clearable>
                <el-option
                  v-for="item in option2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-button class="btn" type="primary" @click="getInvoice"
                >查询
              </el-button>
              <el-button @click="refreshs">刷新</el-button>
            </div>
            <el-table :data="invoiceData" border style="width: 100%">
              <el-table-column prop="createTime" label="申请日期" width="180">
              </el-table-column>
              <el-table-column prop="userName" label="申请人">
              </el-table-column>
              <el-table-column prop="orderId" label="订单编号" width="180">
              </el-table-column>
              <el-table-column prop="name" label="发票状态">
                <template slot-scope="scope">
                  {{
                    scope.row.issueStruts === "1"
                      ? "审核通过"
                      : scope.row.issueStruts === "2"
                      ? "审核拒绝"
                      : scope.row.issueStruts === "3"
                      ? "已开发票"
                      : "尚未审核"
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="extendColumn1" label="发票总金额">
              </el-table-column>
              <el-table-column prop="address" label="地址"></el-table-column>
            </el-table>
            <!-- 开票分页 -->
            <div class="pages">
              <el-pagination
                :current-page="currentPage1"
                :page-size="pageSize1"
                :page-sizes="[5, 10, 20, 30]"
                :total="total1"
                @current-change="handleCurrentChange1"
                @size-change="handleSizeChange1"
                layout="total, sizes, prev, pager, next, jumper"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <!-- 发票申请 -->
        <div class="invoiceListClass" v-if="checked === 3">
          <div class="card">
            <div class="card-top">
              <span></span>
              <h3>可开票申请的订单列表</h3>
            </div>
            <increase-list ref="increaseRef"></increase-list>
          </div>
        </div>
      </div>
    </div>



    <el-dialog
        title="物流跟踪信息"
        :visible.sync="logisticsdialogVisible"
        width="30%" >

      <el-timeline :sreverse="reverse">
        <el-timeline-item
            v-for="(activity, index) in routes"
            :color="index == routes.length-1?'#0bbd87':''"
            :key="index"
            :timestamp="activity.acceptTime">
          {{activity.remark}}
        </el-timeline-item>
      </el-timeline>

     <span slot="footer" class="dialog-footer">
     <el-button type="primary" @click="logisticsdialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>
    <!-- 客户弹框 -->
    <div class="dialogs">
      <el-dialog
        :close-on-click-modal="false"
        title="选择客户"
        :visible.sync="dialogVisible3"
        @close="closed"
      >
        <div class="queryMember">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-input
                v-model.trim="custName1"
                placeholder="请输入用户名称"
              ></el-input
            ></el-col>
            <el-col :span="8">
              <el-button type="primary" @click="queryMember">查询</el-button>
              <el-button @click="refMember">刷新</el-button>
            </el-col>
          </el-row>
        </div>
        <el-table
          :data="allmemberList"
          border
          style="width: 100%"
          class="memberTable"
        >
          <el-table-column header-align="center" align="center" width="100">
            <template scope="scope">
              <el-radio
                :label="scope.row.user_ID"
                v-model="radioMember"
                @change.native="getCurrentRow(scope.row)"
              ></el-radio>
            </template>
          </el-table-column>

          <el-table-column
            property="name"
            label="用户名称"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="联系方式"
            width="180"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.phone ? scope.row.phone : scope.row.username
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            property="createTime"
            label="注册时间"
            width="200"
            header-align="center"
            align="center"
          >
          </el-table-column>
        </el-table>

        <div class="page">
          <el-pagination
            @size-change="handleSizeChange4"
            @current-change="handleCurrentChange4"
            :current-page="pageNumber3"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="pageSize3"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total4"
          >
          </el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelChange">取 消</el-button>
          <el-button type="primary" @click="sureChange">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
          :visible.sync="dialogVisibleFile"
          title="审核文件结果"
          width="45%"
          class="file"
      >
        <div style="display: flex;flex-direction: row;    flex-wrap: nowrap;align-items: center;margin-top: 20px;">
          <div >订单金额: <span style="color:red;">{{ orderFee }}</span>元</div>
          <div  style="margin-left: 50px;">账户余额:<span style="color:red;">{{ lastUserBalance }}</span>元</div>
          <div  style="margin-left: 50px;">授信额度:<span style="color:red;">{{ financeTotalMoney }}</span>元</div>
        </div>
        <el-form ref="approveRef"
                 class="register-form"
                 :model="approveForm"
                 :rules="approveRules"
                 style="margin-top: 20px;"
                 label-width="80">
          <el-form-item label="审核意见:"  >
            <el-input   v-model="approveForm.reviewOpinions" type="textarea" :autosize="{ minRows: 4, maxRows: 10 }" style="width: 600px;"></el-input>
          </el-form-item>
          <el-form-item label="交付时间:" prop="completionTime" >
            <el-date-picker
                format="yyyy-MM-dd"
                placeholder="选择日期"
                type="date"
                :picker-options="pickerOptions0"
                v-model="approveForm.completionTime"
                value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="审核结果:" prop="reviewResultsStatus">
            <el-radio-group v-model="approveForm.fileStatus"  >
              <el-radio key="1"   label="1" >审核通过

                <el-select v-if="approveForm.fileStatus ==1" v-model="approveForm.unit" placeholder="请选择外协单位"  style="width:200px" >
                  <el-option
                      v-for="item in danweiList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                  ></el-option>
                </el-select>
              </el-radio>
              <el-radio key="2"  label="2" >拒绝</el-radio>
            </el-radio-group>

          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleFile = false">取 消</el-button>
          <el-button type="primary" @click="approve()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import pages from "../../components/pages/pagniation";
// import  handleClose from "element-ui/lib/index";

import api from "../../api/invoice/invoice";
import apiWab from "../../api/webAdmin/webAdmin";
import vueQr from "vue-qr";
import OrderDetails from "../OrderDetails/OrderDetails";
import FeeDetails from "../OrderDetails/feeDetails";
import picUrl from "../../api/picture";
import Editor from "../../components/wangeditor/index";
import md5 from "js-md5";
import increaseList from "@/components/personal/increaseList";
//import ObsClient from "../../static/js/esdk-obs-browserjs-3.19.9.min";
import apiList from "@/api/invoice/invoice";
import apiCommon from "@/api/goods/goods";

//var obsClient; // obs实例
import ObsClient from "../../static/js/esdk-obs-browserjs-3.19.9.min";
import url from "../../api/picture";

var obsClient; // obs实例
export default {
  name: "order",
  inject: ["reload"],
  // components: {
  //   pages,
  // },
  components: {
    vueQr,
    OrderDetails,
    FeeDetails,
    Editor,
    increaseList,
  },
  data() {
    return {
      pickerOptions0: {
        disabledDate(time) {
          //如果没有后面的-8.64e7就是不可以选择今天的
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      money: "", //修改订单价格
      editMoneys: false, // 编辑订单价格弹框
      hisData:[],
      orderOldMoney: '',
      hisdialogVisible: false,
      reverse: true,
      routes: [],
      logisticsdialogVisible:false,
      radioMember: "",
      dialogVisibleFile:false,
      financeTotalMoney:0,
      orderFee:0,
      lastUserBalance:0,
      dialogVisible3: false, // 客户弹框
      allmemberList: [], // 弹框客户列表
      pageNumber3: 1,
      pageSize3: 5,
      total4: 0,
      custName1: "", // 客户弹窗筛选
      customerID: "", //筛选条件客服id
      fileStatus: '',
      orderUserId: "", // 筛选条件的客户id
      orderuserName: "", // 客户名称
      productName:   "", // 产品名称
      productType: "", // 产品类型
      productTypeList:[], //产品类型列表
      mallBankInfo: {},
      isPayment: "", // 是否为账期 1 是
      payLoading: false, // 支付loading
      allTotalMoney: 0, // 当前页 订单总金额
      whetherFullPayment: "",
      activities: [], // 订单进度追踪
      showSuer: false, // 支付按钮
      option2: [
        {
          value: "0",
          label: "尚未审核",
        },
        {
          value: "1",
          label: "审核通过",
        },
        {
          value: "2",
          label: "审核拒绝",
        },
        {
          value: "3",
          label: "已开发票",
        },
      ],
      querys: "", // 订单号
      value2: "", // 发票状态
      currentPage1: 1,
      pageSize1: 10,
      total1: 0,
      invoiceData: [], // 开票记录表
      // discountfeeTotal: "", // 订单总金额
      picUrls: "", // 通用网络地址
      fileConfig: false,
      payInfo: {
        // 支付参数
        orderId: "",
        userId: "",
        userfatherid: "",
        paymentProportion: "",
        haveOtherPayment: "",
        paymentChooses: "",
        haveOtherPaymentChooses: "",
      },
      paySuccess: false, // 微信、支付宝 支付成功
      orderMoney: 0, //(实际订单金额)
      orderPay: 0, // 订单实付金额
      credit: 0, //信用额度
      wallet: 0, // 钱包余额
      showPayType: false, //展示支付方式
      showPsBtn: false, //展示引导按钮
      showText: "", //展示文本
      img: "", // 二维码图片
      disabled1: true, //钱包
      disabled2: true, //其他
      disabled3: true, //信用
      checkList: [], // 复选框
      radio: '2', // 单选
      input: "", //支付密码
      changeType: "0", // 是否余额抵扣(0:否，1是)
      payPop: false, // 支付弹窗打开
      batchBpayPop: false, // 批量支付弹窗打开
      showFlag: false,
      fileList: [], // 上传文件列表
      rechargeFrom: {
        ordeRnumber: "",
        type: "",
        userId: "",
        orderId: ""
      },
      danweiList:[],
      approveForm: {
        completionTime: "",
        orderId: "",
        reviewOpinions: "",
        fileStatus: "1",
        unit: "",
        fileReviewer:""
      },
      approveRules: {

        reviewResultsStatus: [
          { required: true, message: "请选择审核结果", trigger: "blur" },

        ],
        completionTime: [
          { required: true, message: "请填写交付日期", trigger: "blur" },

        ],
      },
      approveLog: [], // 审批日志`
      fileData: [
        // {
        //   createTime: "2021-06-03",
        //   orderFileName: "dafd.png",
        //   orderFileStruts: "1",
        // },
      ], // 文件上传列表
      startTime1: "",
      endTime1: "", // 文件上传时间
      orderInfo: {}, // 订单详情
      orderIds:'',
      fileId: "", // 文件id
      billdInfo: {}, //发票信息
      billing: false, // 发票详情弹框
      // orderType: "", // 订单生产状态筛选
      orderPayType: "", // 订单支付状态筛选
      deleted:'',
      customClassType:'',
      options1: [
        // 订单支付状态
        {
          value: "3",
          label: "待支付",
        },
        {
          value: "5",
          label: "已支付",
        },
        {
          value: "0",
          label: "已取消",
        },
      ],
      options2: [
        // 订单支付状态
        {
          value: "0",
          label: "全款",
        },
        // {
        //   value: "1",
        //   label: "30%预付款",
        // },
        {
          value: "2",
          label: "对公转账",
        },
      ],
      options: [
        // 客服
      ],
      currentPage: 1,
      pageSize: 50,
      total: 0,
      checked:1, // 切换模块
      userInfo: [
        {
          id: 1,
          text: "订单查询",
        }
      ],
      // 充值金额
      dynamicValidateForm: {
        recharge: "",
      },
      rules: {
        recharge: [
          { required: true, message: "请输入充值金额", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
      },

      //开始时间
      starttime: "",
      //结束时间
      endtime: "",
      //产品ID
      cpid: "",

      activeName: "first",

      // 表格数据
      tableData: [],

      // tabbar切换下标
      index: "0",

      //上传文件
      dialogVisible: false,

      //进度追踪
      speed: false,
      userId: "",

      detail: false, // 订单详情弹窗打开
      feedetail: false,
      title: "", //订单详情弹窗打开标题
      // OrderDetails:'',//订单详情
      timer: "",
      phone: "", // 当前用户手机号
      selectList: [],
      batchPayInfoForm: {},
      batchPayPop: false, // 批量支付弹窗打开
      onlinePayPop: false, // 线下支付弹窗打开
      complaints: false, // 投诉弹窗打开
      complaintsList: [], //投诉列表
      //投诉分类
      ComplaintClassification: [
        { name: "质量", id: 0 },
        { name: "数量", id: 1 },
        { name: "交期", id: 2 },
        { name: "物流", id: 3 },
        { name: "包装", id: 4 },
        { name: "服务", id: 5 },
        { name: "印前", id: 6 },
        { name: "其他", id: 7 },
      ],
      //投诉内容
      form: {
        text: "",
        types: [],
      },
      rule: {
        types: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个投诉分类",
            trigger: "change",
          },
        ],
        text: [{ required: true, message: "请填写投诉内容", trigger: "blur" }],
      },
      filename:'',
      fileName: '',
      obsAccessKeyId: "", //key   初始化使用
      obsBucketName: "", //桶名称
      obsFileDir: "", //文件夹
      obsSecretAccessKey: "", //秘钥   初始化使用
      obsServer: "", //服务器地址  初始化使用
      posterURL: "", //上传的文件名
      userType: 0, // 当前账户角色
      payPass: false, // 支付密码是否校验成功
      checks: false, //有支付密码
      showMessage: true,
      newPwdReadOnly: false,
      threePay: false, //余额加信用不足

      //上传文件第几页
      currentPagefile: 1,
      //上传文件每页条数
      pageSizefile: 10,
      //上传文件总条数
      filetotal: 0,
      //上传文件_时间戳
      Filename: "",
      //上传文件_加载遮罩层
      loading: "",
      //浏览地址
      BrowseUrl: "",
      offlineOrderMoney: "",
      upStre: 1,
      customerName: "",
      orderId: "",
      orderName: '',
      quoteDesc: '',
      custRemark: '',
      editQuoteDesc: false,
      invoiceConfigMap: null
    };
  },
  watch: {
    radio(v) {
      console.log("监听单选", v);
      this.checkList = [];
      // this.checkGroup();
      // this.input = "";
      if (this.radio === "0") {
        console.log("执行了这里");
        this.disabled1 = this.disabled2 = this.disabled3 = true;
        this.showSuer = true;
      } else if (v === "3") {
        this.disabled1 = this.disabled2 = this.disabled3 = true;
        this.showSuer = true;
        this.offlineOrderMoney = this.orderMoney * this.upStre;
      } else if (v === "1") {
        this.orderPay = this.orderMoney * 0.3;
        this.disabled1 = this.disabled2 = this.disabled3 = false;
      } else if (v === "2") {
        this.orderPay = this.orderMoney;
        this.disabled1 = this.disabled2 = this.disabled3 = false;
      }
      if (this.wallet <= 0) {
        this.disabled1 = true;
      }
      if (this.credit <= 0) {
        this.disabled3 = true;
      }
    },
    checkList(v) {
      console.log("复选框变化", v);
      if (v.length > 0) {
        let other = v.some((el) => el === "2"); //支付宝微信
        let pay = v.some((el) => el === "3");
        let balance = v.some((el) => el === "1"); // 余额支付
        console.log("存在其他", other);
        if (other && v.length > 1) {
          this.img = "";
          this.showText = 0;
          this.showPsBtn = false; // 支付宝微信按
          this.showSuer = false; //确认按钮
        }
        if (balance) {
          // 余额
          if (this.wallet >= this.orderPay) {
            this.disabled2 = true;
            let index = v.findIndex((el) => el === "2");
            console.log("获取下标", index);
            if (index !== -1) {
              this.checkList.splice(index, 1);
            }
            //if (this.userType !== 0) {
              // 代客支付 不需要支付验证
              this.changeType = "0";
              this.showSuer = false;
            //}
          } else {
            if (v.length === 1) {
              this.$message.warning("当前余额不足,请配合其他方式支付！");
              this.showSuer = true;
            }
          }
          if (this.credit <= 0) {
            this.disabled3 = true;
          } else {
            this.showSuer = true;
          }
        }
        if (pay) {
          // 信用
          if (this.credit >= this.orderPay) {
            this.disabled1 = true;
            this.disabled2 = true;
            this.disabled3 = false;
            this.showSuer = false;
            let index = v.findIndex((el) => el === "2");
            console.log("获取下标", index);
            if (index !== -1) {
              this.checkList.splice(index, 1);
            }
            let index1 = v.findIndex((el) => el === "1");
            console.log("获取下标", index1);
            if (index1 !== -1) {
              this.checkList.splice(index1, 1);
            }
          } else {
            if (v.length === 1) {
              this.$message.warning("当前信用额度不足,请配合其他方式支付！");
              this.showSuer = true;
            }
          }
        } else {
          console.log("执行了else");
          this.disabled1 = this.disabled2 = false;
          this.changeType = "0";
          if (this.wallet <= 0) {
            this.disabled1 = true;
          }
        }
        if (pay && balance) {
          if (this.wallet + this.credit >= this.orderPay) {
            this.disabled2 = true;
            let index = v.findIndex((el) => el === "2");
            console.log("获取下标", index);
            if (index !== -1) {
              this.checkList.splice(index, 1);
            }
          } else {
            this.disabled2 = false;
            this.showSuer = true;
            this.threePay = true;
          }
        } else {
          if (balance) {
            if (this.wallet >= this.orderPay) {
              this.disabled2 = true;
            } else {
              this.disabled2 = false;
              this.showSuer = true;
             // if (this.userType !== 0) {
                // 代客支付 不需要支付验证
                this.changeType = "0";
              //}
            }
          }
          if (pay) {
            if (this.credit >= this.orderPay) {
              this.disabled2 = true;
            } else {
              this.disabled2 = false;
              this.showSuer = true;
            }
          }
        }
        // if (pay || balance) {
        //   if (this.userType !== 0) {
        //     // 代客支付 不需要支付验证
        //     this.changeType = "0";
        //   }
        //   else {
        //     this.changeType = "1";
        //   }
        // } else {
        //   this.changeType = "0";
        // }

        this.changeType = "0";
        if (other) {
          this.showPayType = true;
          if (this.changeType === "1") {
            if (this.payPass) {
              // 支付密码正确
              this.showSuer = false;
            }
          } else {
            this.showSuer = false;
          }
        } else {
          this.showPayType = false; //隐藏付款方式
          this.showPsBtn = false; // 隐藏引导按钮
          this.img = "";
          this.showText = "";
        }
      } else {
        // if (this.radio && this.radio !== "3") {
        //   this.disabled1 = this.disabled2 = this.disabled3 = false;
        // }
        console.log("复选框为0");
        if (this.wallet <= 0) {
          this.disabled1 = true;
        } else {
          this.disabled1 = false;
        }
        if (this.credit <= 0) {
          this.disabled3 = true;
        }
        if (this.radio !== "3" && this.radio !== "0") {
          console.log("执行了这里");
          this.disabled2 = false;
          this.showSuer = true;
        }
        this.showPayType = false; //隐藏付款方式
        this.showPsBtn = false; // 隐藏引导按钮
        this.img = "";
        this.showText = "";
        this.changeType = "0";
      }
    },
    changeType(v) {
      if (v === "1") {
        this.checks = true;
        if (this.payPass) {
          this.showSuer = true;
        }
      } else {
        this.checks = false;
      }
    },
    input(v) {
      if (this.changeType === "1") {
        if (v === "") {
          this.newPwdReadOnly = true;
          this.newPwdFocus(null);
        }
      }
    },
  },
  created() {

    this.picUrls = picUrl.picUrl;
    let obj = JSON.parse(window.sessionStorage.getItem("currentInfo"));
    let isInvoice = window.sessionStorage.getItem("customer")? JSON.parse(window.sessionStorage.getItem("customer")).isInvoice:2;
    // console.log("获取用户信息", obj);
    if (obj) {
      this.userId = obj.user_ID;
      this.phone = obj.phone;
      this.userType = obj.userType;
      // 管理员展示不同文案
      if (obj.userType === 0 && isInvoice ==='1') {
        this.userInfo.push(
            {
              id: 2,
              text: "发票申请",
            })
      }
    } else {
      return;
    }
    //上传文件日期_默认当前日期
    // let year = new Date().getFullYear(); //得到年份
    // let month = new Date().getMonth(); //得到月份
    // let date = new Date().getDate(); //得到日期
    // month = month + 1;
    // if (month < 10) month = "0" + month;
    // if (date < 10) date = "0" + date;
    // this.endTime1 = year + "-" + month + "-" + date;

    this.$route.params.jump;
    console.log(this.$route.params.jump);
    console.log(this.$route.params.jumptext);
    let jumptext = this.$route.params.jumptext;
    if (jumptext) {
      this.orderType = this.$route.params.jumptext;
    }
   // this.getCurrentMonthFirst();
    this.getCurrentDay();
    this.getService();
    this.init(1);
    this.getConfig();
    this.getInvoiceConfig();
    this.getProductType();
    this.info();
    this.getUserInfos();
    this.queryUnit();
    this.initOBS();
  },
  computed: {

    discountfeeTotal() {
      if (this.selectList.length > 0) {
        return this.selectList.reduce((pav, next) => {
          return pav + Number(next.discountfee);
        }, 0);
      } else {
        return 0;
      }
    },
  },
  filters: {
    numbers(value) {
      let relval = 0;
      if (!isNaN(value) && value !== "") {
        relval = parseFloat(value).toFixed(2);
      } else {
        relval = 0;
      }
      return relval;
    },
  },
  methods: {
    queryUnit(){
      api
          .queryDanwei()
          .then((res) => {
            if (res.success) {
              this.danweiList = res.data
            }
          })
    },
    getUserInfos() {
      api
          .getUserMoneyAndCredits(2, null)
          .then((res) => {
            console.log("获取用户详情", res);
            if (res.success) {
              this.wallet = res.data.balance;
            }
          })
          .catch((error) => {
            console.error("error", error);
          });
    },
    getCurrentMonthFirst() {
      var date1 = new Date()
      date1.setDate(1)
      date1.setMonth(parseInt(date1.getMonth())-1)
      var date2 = new Date(date1)
      var year = date2.getFullYear()
      var month = date2.getMonth()+1
      var day = date2.getDate()
      month = (month > 9) ? month : ('0' + month)
      day = (day < 10) ? ('0' + day) : day
      this.starttime = year + '-' + month + '-' + day
    },
    getCurrentDay() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      month = (month > 9) ? month : ('0' + month)
      day = (day < 10) ? ('0' + day) : day
      this.starttime = year + '-' + month + '-' + day
      this.endtime = year + '-' + month + '-' + day

    },
    info(){
      this.$http.get("/companyprofile/listAll").then((res) => {
        console.log("转账信息", res);
        if (res.data.code == 200) {
          this.mallBankInfo = res.data.data[0].mallBankInfo
        } else {
          this.$message.error("查询失败");
        }
      })
    },
    getProductType(){
      apiWab
          .queryProductType()
          .then((res) => {
            if (res.success) {
              this.productTypeList = res.data
            }
          })
    },
    getInvoiceConfig() {
      api
          .getInvoiceConfig()
          .then((res) => {
            if (res.success) {
              this.invoiceConfigMap = res.data
            }
          })
    },
    getConfig() {
      api
          .getConfig()
          .then((res) => {
            if (res.success) {
              this.fileConfig = res.data
            }
          })
          .catch((error) => {
            console.error("error", error);
          });
    },

    // 确定修改订单总额
    sureEdit() {
      if (this.money === "") {
        this.$message.warning("请输入需要修改的金额");
        return;
      }
      api
          .orderEditPrice(this.orderId, this.money,this.orderOldMoney)
          .then((res) => {
            // console.log("修改用户信息", res);
            if (res.success) {
              this.$message.success("修改成功");
              this.init(this.checked);
              this.editMoneys = false;
              this.orderId = "";
            } else {
              this.$message.error("修改失败");
            }
          })
          .catch((error) => {
            console.error("error", error);
          });
    },
    quoteDescEdit(){
      if (this.quoteDesc === "") {
        this.$message.warning("请输入订单详情");
        return;
      }
      api
          .orderEditQuoteDesc(this.orderId, this.quoteDesc, this.custRemark)
          .then((res) => {
            if (res.success) {
              this.$message.success("修改成功");
              this.orderId = "";
              this.init(this.checked);
              this.editQuoteDesc = false;

              this.quoteDesc = "";
              this.custRemark = "";
            } else {
              this.$message.error("修改失败，"+res.message);
            }
          })
          .catch((error) => {
            this.$message.error("修改失败");
            console.error("error", error);
          });
    },

    // 删除订单
    delleteOrder(item) {

      this.$confirm("此操作将永久删除该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api.deleOrder(item.id).then((res) => {
            console.log("删除当前订单", res);
            if (res.success) {
              this.$message({
                type: "success",
                message: "取消成功!",
              });
              // 刷新表格
              this.init(this.checked);
            } else {
              this.init(this.checked);
              this.$message.error("取消失败" + res.message)
            }
          });
        })
        .catch(() => {

        });
    },
    cancelChange() {
      this.radioMember = "";
      this.orderUserId = "";
      this.orderuserName = "";
      this.dialogVisible3 = false;
    },
    sureChange() {
      if (this.radioMember === "") {
        this.$message.warning("请选择客户！");
        return;
      }
      this.query();
      this.dialogVisible3 = false;
    },
    // 单选
    getCurrentRow(item) {
      console.log(item);
      this.orderUserId = item.customerId;
      this.orderuserName = item.name;
    },
    queryMember() {
      this.getCustomer();
    },
    refMember() {
      this.custName1 = "";
      this.pageNumber3 = 1;
      this.pageSize3 = 5;
      this.getCustomer();
    },
    // 弹窗关闭操作
    closed() {
      if (!this.dialogVisible3) {
        // this.dialogVisible3 = false;
        if (this.radioMember === "") {
          this.orderUserId = ""; // 选择客户id
          this.custName1 = ""; // 筛选条件清空
          this.orderuserName = ""; //选择客户名称
        }
      }
    },
    // 获取客户
    getCustomer() {
      apiWab
        .queryUser(
          this.pageNumber3,
          this.pageSize3,
          "",
          "",
          this.custName1,
          "0"
        )
        .then((res) => {
          console.log("获取客户", res);
          if (res.success) {
            // this.allList = res.data.userPageInfo.list;
            this.allmemberList = res.data.list;
            this.total4 = res.data.total;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 选择客户
    changeMember() {
      this.custName1 = "";
      this.dialogVisible3 = true;
      this.radioMember = "";
      this.getCustomer();
    },
    // 获取所有客服
    getService() {
      apiWab.getAllUserDontExistCustom().then((res) => {
        console.log("获取客服", res);
        if (res.success && res.code == 200) {
          res.data.userPageInfo.forEach((el) => {
            el.label = el.name;
            el.value = el.user_ID;
          });
          this.options = res.data.userPageInfo;
        } else {
          this.$message.error("获取客服失败");
        }
      });
    },
    // 判断生产状态
    typeFunc(v) {
      let text = "";
      if (v === "-1") {
        return (text = "待核价");
      } else if (v === "1") {
        return (text = "待审核");
      } else if (v === "2") {
        return (text = "待排产");
      } else if (v === "3") {
        return (text = "生产中");
      } else if (v === "4") {
        if (this.userType === 0) {
          return (text = "生产完成");
        } else {
          return (text = "待入库");
        }
      } else if (v === "5") {
        if (this.userType === 0) {
          return (text = "待发货");
        } else {
          return (text = "已入库");
        }
      } else if (v === "6") {
        if (this.userType === 0) {
          return (text = "已发货");
        } else {
          return (text = "待签收");
        }
      } else if (v === "7") {
        return (text = "订单取消");
      } else if (v === "8") {
        return (text = "订单完成(已评价)");
      } else if (v === "9") {
        return (text = "待印前制作");
      } else if (v === "10") {
        return (text = "待客确认");
      } else if (v === "11") {
        return (text = "已收货");
      } else {
        return text;
      }
    },

    refresh() {
      this.whetherFullPayment = this.starttime = this.endtime = this.orderPayType =
        "";
      this.customerID = "";
      this.orderUserId = "";
      this.orderuserName = "";

      this.productType = "";
      this.productName = "";
      this.init(this.checked);
    },
    // 关闭支付弹窗
    closeDlg() {
      this.input = "";
      this.orderPay = 0;
      this.stopPass();
    },
    wacthChange(value) {
      if (value.length === 6) {
        this.$refs.inputPs.blur();
      }
    },
    // 阻止密码框自动填充
    stopPass() {
      console.log("调用了回调");
      if (this.$refs.inputPs) {
        console.log("执行了判断");
        this.$refs.inputPs.$refs.input.onmousedown = (evt) => {
          console.log("执行了点击", evt);
          if (evt) {
            evt.preventDefault();
            evt.stopPropagation();
          }
          if (this.input === "" || this.newPwdReadOnly) {
            this.$refs.inputPs.$refs.input.blur();
            setTimeout(() => {
              this.$refs.inputPs.$refs.input.focus();
            }, 0);
          }
          return false;
        };
      }
    },
    newPwdFocus(evt, isNew = true) {
      console.log("获取焦点");
      if (evt) {
        evt.stopPropagation();
        evt.preventDefault();
      }
      setTimeout(() => {
        if (isNew) {
          this.newPwdReadOnly = false;
        } else {
          this.rePwdReadOnly = false;
        }
      }, 100);
    },
    // 失去焦点触发事件（支付密码）
    blurs(evt, isNew = true) {
      if (evt) {
        evt.stopPropagation();
      }
      if (isNew) {
        this.newPwdReadOnly = true;
      } else {
        this.rePwdReadOnly = true;
      }
      if (this.threePay) {
        this.$message.warning("当前金额不足,请配合其他方式支付！");
        return;
      }
      // console.log(event);
      if (this.changeType === "1") {
        if (this.input === "") {
          this.$message.error(
            "请输入支付密码!如若未设置或者忘记，请到费用中心设置支付密码!"
          );
          this.showSuer = true; // 支付弹窗按钮禁用
          this.payPass = false;
          return;
        } else {
          // let ps = md5(this.input);
          let data = {
            userName: this.userId,
            pwd: md5(this.input),
          };
          api
            .checkPayPassWord(data)
            .then((res) => {
              if (res.success) {
                this.showSuer = false;
                this.payPass = true;
              } else {
                this.$message.error(res.message);
                this.payPass = false;
                this.showSuer = true;
                this.showMessage = false;
              }
            })
            .catch((error) => {
              console.error("error", error);
              this.payPass = false;
              this.showSuer = true;
              this.showMessage = false;
            });
        }
      } else {
        this.showSuer = false;
      }
    },
    // 刷新开票记录
    refreshs() {
      this.value2 = this.querys = "";
      this.getInvoice();
    },
    // 获取开票记录
    getInvoice() {
      api
        .invoiceList(
          this.pageSize1,
          this.currentPage1,
          this.querys,
          this.value2
        )
        .then((res) => {
          console.log("获取用户开票列表", res);
          if (res.success) {
            this.invoiceData = res.data.list;
            this.total1 = res.data.total;
          }
        });
    },
    // 确认开发票
    sureBill() {
      if (this.selectList.length <= 0) {
        this.$message.warning("请选择订单列表前的多选框(仅限当前页可选订单)");
        return;
      }
      let len = this.selectList.length;
      let obj = this.selectList;
      let arr = [];
      for (let i = 0; i < len; i++) {
        let id = obj[i].id;
        arr.push(id);
      }
      if (arr.length === 1) {
        arr[0] = arr[0] + ",";
      }
      console.log("处理后的订单低集合", arr);
      let data = {
        userId: this.userId,
        orderId: arr.join(","),
      };
      api.applyKai(data).then((res) => {
        console.log("开票成功", res);
        if (res.success) {
          this.$message.success("开票成功");
          this.billing = false;
          this.init(this.checked);
        } else {
          this.$message.error("开票失败");
        }
      });
      console.log(data);
    },
    // 多选框禁用
    selectEnable(row) {
      console.log(row);
      if (row.deleted == 0 && row.payStruts !== 5) {
        return true;
      } else {
        return false;
      }
    },
    moreSelect(selection, row) {
    },
    changeSelect(selection) {
      console.log(selection);
      this.selectList = selection;
      this.allTotalMoney = this.selectList.reduce((total, item) => total + (Number(item.discountfee) || 0), 0)
      this.showFlag = true
    },

    // 获取用户详情
    getUserInfo(id) {
      api
        .getUserMoneyAndCredits(1, id)
        .then((res) => {
          // console.log("获取用户详情", res);
          if (res.success) {
            this.credit = Number(res.data.credits); //信用额度
            this.wallet = Number(res.data.balance); // 钱包余额
            this.upStre = res.data.upRate ? Number(res.data.upRate) : 1;
            this.customerName = res.data.user.name;
            this.isPayment = res.data.user.isPayment;
            if (this.wallet <= 0) {
              this.disabled1 = true;
            }
            if (this.credit <= 0) {
              this.disabled3 = true;
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          console.error("error", error);
        });
    },
    clearOnlinePayData(){
      this.payInfo = {
        orderId: "",
        userId: "",
        userfatherid: "",
        paymentProportion: "",
        haveOtherPayment: "",
        paymentChooses: "",
        haveOtherPaymentChooses: "",
      };
      this.showText = '';
      this.orderPay = 0;
      this.onlinePayPop = false;
      this.img = "";
    },
    clearBatchPayData(){
      this.payInfo = {
        orderId: "",
        userId: "",
        userfatherid: "",
        paymentProportion: "",
        haveOtherPayment: "",
        paymentChooses: "",
        haveOtherPaymentChooses: "",
      };
      this.orderPay = 0;
      this.batchPayPop = false;
      this.img = "";
      this.showPsBtn = false;
      this.showText = 0;
      this.showPayType = false;
      this.changeType = "0";
      this.checkList = [];
      this.radio = "";
      this.input = "";
    },
    // 清除支付参数
    clearPayData() {
      this.payInfo = {
        orderId: "",
        userId: "",
        userfatherid: "",
        paymentProportion: "",
        haveOtherPayment: "",
        paymentChooses: "",
        haveOtherPaymentChooses: "",
      };
      this.payPop = false;
      this.img = "";
      this.showPsBtn = false;
      this.showText = 0;
      this.showPayType = false;
      this.changeType = "0";
      this.checkList = [];
      this.radio = "";
      this.input = "";
    },
    comitBatchPay() {
      this.payBatchData();
      this.payLoading = true;
      if (this.showPayType) {
        if (this.img === "") {
          this.$message.warning("请选择支付方式，微信或支付宝");
          this.payLoading = false;
          return;
        }
        this.surePay(); // 确认是否支付成功
        if (this.paySuccess) {
          this.clearPayData();
        } else {
          // this.$message.warning("请确定是否扫码支付成功？");
          return;
        }
        console.log(this.payInfo);
      } else {
        if (this.changeType === "1") {
          if (this.payPass) {
            console.log("验证成功");
          } else {
            if (this.showMessage) {
              this.$message.warning("请输入支付密码！");
              return;
            }
            return;
          }
        }

        console.log("支付参数", this.payInfo);
        api
            .orderpayinfo(this.payInfo)
            .then((res) => {
              this.payLoading = false;
              console.log("单独支付成功", res);
              if (res.success) {
                this.$message.success("支付成功");
                this.clearPayData();
                this.init(this.checked);
                this.batchPayPop = false;
                this.getUserInfos();

              } else {
                this.$message.error(res.message);
              }
            })
            .catch((error) => {
              console.error("error", error);
            });
        console.log(this.payInfo);
      }
      // this.payPop = false;
    },
    // 支付弹窗确定按钮(未使用扫码支付)
    comitPay() {
      this.payData();
      this.payLoading = true;
      if (this.showPayType) {
        if (this.img === "") {
          this.$message.warning("请选择支付方式，微信或支付宝");
          this.payLoading = false;
          return;
        }
        this.surePay(); // 确认是否支付成功
        if (this.paySuccess) {
          this.clearPayData();
        } else {
          // this.$message.warning("请确定是否扫码支付成功？");
          return;
        }
        console.log(this.payInfo);
      } else {
        if (this.changeType === "1") {
          if (this.payPass) {
            console.log("验证成功");
          } else {
            if (this.showMessage) {
              this.$message.warning("请输入支付密码！");
              return;
            }
            return;
          }
        }
        if (this.radio === "3") {
          this.payInfo.paymentProportion = 5;
          this.payInfo.orderMoney = this.orderInfo.discountfee;
        }
        console.log("支付参数", this.payInfo);
        api
          .orderpayinfo(this.payInfo)
          .then((res) => {
            this.payLoading = false;
            console.log("单独支付成功", res);
            if (res.success) {
              this.$message.success("支付成功");
              this.clearPayData();
              this.init(this.checked);
              this.getUserInfos();
              this.payPop = false;
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((error) => {
            console.error("error", error);
          });
      }

    },
    payBatchData() {
      let info = this.orderInfo;
      let data = this.payInfo;

      data.orderId = info.orderId;
      data.userId = info.userId;
      data.userfatherid = info.userfatherid;
      // 付款方式
      if (this.radio === "2") {
        data.paymentProportion = 2; // 全款支付
      }
      // 支付方式
      let arr = [...this.checkList];
      console.log(arr, data);
      if (arr.length === 1) {
        console.log("单选");
        if (arr[0] === "1") {
          // 余额支付
          data.paymentChooses = 1; // 余额
          data.haveOtherPayment = 1; // 不需要支付宝
        } else if (arr[0] === "2") {
          // 其他支付
          data.haveOtherPayment = 3; // 单独支付宝
          data.paymentChooses = "";
        } else {
          // 信用支付
          data.haveOtherPayment = 1; // 不需要支付宝
          data.paymentChooses = 2; // 信用
        }
      }
      if (arr.length === 2) {
        console.log("执行了多选");
        console.log(arr.join("."));
        let str = arr.join(".");
        if (str === "1.2" || str === "2.1") {
          console.log("余额加支付宝");
          data.haveOtherPayment = 2; // 需要支付宝
          data.paymentChooses = 1; // 余额
        } else if (str === "1.3" || str === "3.1") {
          console.log("二合一");
          data.haveOtherPayment = 1; // 不需要支付宝
          data.paymentChooses = 3;
        } else {
          console.log("信用加支付宝");
          data.haveOtherPayment = 2; // 需要支付宝
          data.paymentChooses = 2; // 信用
        }
      }
      if (arr.length === 3) {
        data.haveOtherPayment = 2; // 需要支付宝
        data.paymentChooses = 3; // 信用，余额二合一
      }


    },
    // 处理参数
    payData() {
      let info = this.orderInfo;
      let data = this.payInfo;
      data.orderId = info.id;
      data.userId = info.userid;
      data.userfatherid = info.userfatherid;
      // 付款方式
      if (this.radio === "1") {
        data.paymentProportion = 1; // 首付30%
      } else if (this.radio === "2") {
        data.paymentProportion = 2; // 全款支付
      } else if (this.radio === "3") {
        data.paymentProportion = 3; // 线下付款
        data.haveOtherPayment = "";
        data.paymentChooses = "";
        data.haveOtherPaymentChooses = "";
      }
      // 支付方式
      let arr = [...this.checkList];
      console.log(arr, data);
      if (arr.length === 1) {
        console.log("单选");
        if (arr[0] === "1") {
          // 余额支付
          data.paymentChooses = 1; // 余额
          data.haveOtherPayment = 1; // 不需要支付宝
        } else if (arr[0] === "2") {
          // 其他支付
          data.haveOtherPayment = 3; // 单独支付宝
          data.paymentChooses = "";
        } else {
          // 信用支付
          data.haveOtherPayment = 1; // 不需要支付宝
          data.paymentChooses = 2; // 信用
        }
      }
      if (arr.length === 2) {
        console.log("执行了多选");
        console.log(arr.join("."));
        let str = arr.join(".");
        if (str === "1.2" || str === "2.1") {
          console.log("余额加支付宝");
          data.haveOtherPayment = 2; // 需要支付宝
          data.paymentChooses = 1; // 余额
        } else if (str === "1.3" || str === "3.1") {
          console.log("二合一");
          data.haveOtherPayment = 1; // 不需要支付宝
          data.paymentChooses = 3;
        } else {
          console.log("信用加支付宝");
          data.haveOtherPayment = 2; // 需要支付宝
          data.paymentChooses = 2; // 信用
        }
      }
      if (arr.length === 3) {
        data.haveOtherPayment = 2; // 需要支付宝
        data.paymentChooses = 3; // 信用，余额二合一
      }
    },
    //确定支付成功(查询是否支付成功)
    surePay() {
      if (this.changeType === "1") {
        if (this.payPass) {
          // this.$message.success("支付密码正确");
        } else {
          this.$message.warning("支付密码验证未通过,请重新确认支付密码");
          return;
        }
      }
      api
        .queryPassType(this.rechargeFrom)
        .then((res) => {
          this.payLoading = false;
          // console.log("查询支付状态", res);
          if (res.success) {
            if (
              res.data.result === "TRADE_SUCCESS" ||
              res.data.result === "SUCCESS"
            ) {
              this.paySuccess = true;
              this.$message.success("支付成功");
              // this.stopPass();
              this.clearPayData();
              this.init(this.checked);
            } else {
              this.$message.warning("未查询到支付成功，请确认支付是否成功");
            }
          }
        })
        .catch((error) => {
          console.error("error", error);
        });
    },
    onlineBills(str) {
      let obj = JSON.parse(window.sessionStorage.getItem("currentInfo"));
      let userId = obj.user_ID;

      if (
          this.orderInfo.discountfee === "" ||
          this.orderInfo.discountfee === "0"
      ) {
        this.$message.warning("订单金额不能为0");
        return;
      }
      let data = {
        orderId: this.orderIds,
        userId: userId,
        money: this.orderInfo.discountfee,
        type: 1,
      };
      // 微信
      if (str === "wx") {
        console.log("微信支付");
        data.incomeType = 2;
      } else {
        // 支付宝
        console.log("支付宝支付");
        data.incomeType = 1;
      }
      console.log("调整后的参数数据", data);
      // this.img =
      api
          .recharge(data)
          .then((res) => {
            console.log("调取获取二维码", res);
            if (res.success) {
              this.img = res.data.qrCode;
              this.showSuer = false;
              if (data.incomeType === 2) {
                // 微信
                this.showText = 1;
                this.rechargeFrom = {
                  ordeRnumber: res.data.orderNumber,
                  type: 2,
                  userId: userId,
                };
              } else {
                // 支付宝
                this.showText = 2;
                this.rechargeFrom = {
                  ordeRnumber: res.data.orderNumber,
                  type: 1,
                  userId: userId,
                };
              }
            } else {
              this.$message.error("获取支付二维码失败");
            }
          })
          .catch((error) => {
            console.error("error", error);
          });
    },
    comitOnlinePay(){
      api
          .queryPassType(this.rechargeFrom)
          .then((res) => {
            if (res.success) {
              if (
                  res.data.result === "TRADE_SUCCESS" ||
                  res.data.result === "SUCCESS"
              ) {
                this.showText = '';
                this.img = "";
                 this.orderInfo.discountfee = "";
                this.showSuer = true;
                this.orderId = '';
                this.onlinePayPop = false;
                this.showPsBtn = false;
                this.$message.success("支付成功");
                this.init(this.checked);
              }
              else {
                this.$message.warning("未查询到支付成功，请确认支付是否成功");
              }
            }
          })
          .catch((error) => {
            console.error("error", error);
          });
    },
    billsBatch(str) {
      this.payBatchData();
      if (this.checks) {
        if (this.payPass) {
          console.log("验证成功");
        } else {
          this.$message.warning("请先验证支付密码!");
          return;
        }
      }
      // 微信
      if (str === "wx") {
        console.log("微信支付");
        this.payInfo.haveOtherPaymentChooses = 2;
      } else {
        // 支付宝
        console.log("支付宝支付");
        this.payInfo.haveOtherPaymentChooses = 1;
      }
      console.log("调整后的参数数据", this.payInfo);
      api
          .orderpayinfo(this.payInfo)
          .then((res) => {
            console.log("调取获取二维码", res);
            if (res.success) {
              this.img = res.data.qrCode;
              this.showPsBtn = true;
              if (this.payInfo.haveOtherPaymentChooses === 2) {
                // 微信
                this.showText = 1;
                this.rechargeFrom = {
                  ordeRnumber: res.data.otherPayOrderId,
                  type: 2,
                  userId: this.payInfo.userId,
                  orderId: this.payInfo.orderId
                };
              } else {
                // 支付宝
                this.showText = 2;
                this.rechargeFrom = {
                  ordeRnumber: res.data.otherPayOrderId,
                  type: 1,
                  userId: this.payInfo.userId,
                  orderId: this.payInfo.orderId
                };
              }
              // console.log(this.rechargeFrom);
            } else {
              this.$message.error("获取支付二维码失败");
            }
          })
          .catch((error) => {
            console.error("error", error);
          });
    },
    // 支付选择
    bills(str) {
      this.payData();
      if (this.checks) {
        if (this.payPass) {
          console.log("验证成功");
        } else {
          this.$message.warning("请先验证支付密码!");
          return;
        }
      }
      // 微信
      if (str === "wx") {
        console.log("微信支付");
        this.payInfo.haveOtherPaymentChooses = 2;
      } else {
        // 支付宝
        console.log("支付宝支付");
        this.payInfo.haveOtherPaymentChooses = 1;
      }
      console.log("调整后的参数数据", this.payInfo);
      api
        .orderpayinfo(this.payInfo)
        .then((res) => {
          console.log("调取获取二维码", res);
          if (res.success) {
            this.img = res.data.qrCode;
            this.showPsBtn = true;
            if (this.payInfo.haveOtherPaymentChooses === 2) {
              // 微信
              this.showText = 1;
              this.rechargeFrom = {
                ordeRnumber: res.data.otherPayOrderId,
                type: 2,
                userId: this.payInfo.userId,
                orderId: this.payInfo.orderId
              };
            } else {
              // 支付宝
              this.showText = 2;
              this.rechargeFrom = {
                ordeRnumber: res.data.otherPayOrderId,
                type: 1,
                userId: this.payInfo.userId,
                orderId: this.payInfo.orderId
              };
            }
            // console.log(this.rechargeFrom);
          } else {
            this.$message.error("获取支付二维码失败");
          }
        })
        .catch((error) => {
          console.error("error", error);
        });
    },
    // 复选框内容
    checkGroup(val) {
      console.log(val);
      // if (val) {
      //   let balance = val.some((el) => el === "1"); // 钱包抵扣
      //   let other = val.some((el) => el === "2"); // 其他
      //   let credit1 = val.some((el) => el === "3"); // 信用
      //   console.log("是否选择了余额抵扣", balance);
      //   console.log("是否选择了其他", other);
      //   console.log("是否选择了信用", credit1);
      //   // console.log("是否选择了组合支付", towPay);
      //   let sure = false; // 余额满足
      //   let sure1 = false; // 信用满足
      //   if (balance) {
      //     //选择了余额抵扣
      //     this.changeType = "1";
      //     if (this.wallet > this.orderPay) {
      //       sure = true;
      //     }
      //     if (sure) {
      //       console.log("执行了禁用", sure);

      //       this.disabled2 = this.disabled3 = true;
      //     }
      //   } else {
      //     sure = false;
      //     if (!sure) {
      //       this.disabled2 = this.disabled3 = false;
      //     }
      //     this.changeType = "0"; // 隐藏支付密码
      //   }
      //   if (other) {
      //     // 选择了其他
      //     this.showPayType = true;
      //   } else {
      //     this.showPayType = false; //隐藏付款方式
      //     this.showPsBtn = false; // 隐藏引导按钮
      //     this.img = "";
      //     this.showText = "";
      //   }
      //   if (credit1) {
      //     //选择了信用抵扣

      //     this.changeType = "1";
      //     if (this.credit > this.orderPay) {
      //       sure1 = true;
      //     }
      //     if (sure1) {
      //       this.disabled1 = this.disabled2 = true;
      //     }
      //   } else {
      //     if (sure) {
      //       this.changeType = "1"; // 显示支付密码
      //       this.disabled2 = this.disabled3 = true;
      //     } else {
      //       sure1 = false;
      //       if (!sure1) {
      //         this.disabled2 = this.disabled1 = false;
      //       }
      //     }
      //   }
      // } else {
      //   this.changeType = "0";
      //   this.showPayType = false;
      //   this.img = "";
      //   this.showPsBtn = false;
      // }
    },

    //点击文件列表中已上传的文件时的钩子
    handlePreview(file) {
      console.log(file);
    },

    //删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除。
    befRemove(file, fileList) {
      console.log(file, fileList);
      if (file.status == "uploading") {
        this.$message({
          message: "文件正在上传中，请勿关闭",
          type: "warning",
        });
        return false;
      }
    },

    //文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    handChange(file, fileList) {
      console.log(file, fileList);
      if (fileList.length > 1) {
        this.$message({
          message: "请选择单个文件进行上传",
          type: "warning",
        });
      }
      console.log(file.raw);
      //删除文件列表除最后一个文件
      fileList.splice(0, fileList.length - 1);
      console.log(file, URL.createObjectURL(file.raw));
      this.fileList = fileList;
      this.posterURL = file.raw; // 获取URL
      console.log(this.posterURL);
      console.log(this.posterURL.name.match(/\.([^\.]+)$/)[0]);
      // } else {
      //   this.$message.error("请选择图片文件");
      // }
    },

    //文件上传时的钩子
    onProgress(event, file, fileList) {
      console.log(event, file, fileList);
        const loading = this.$loading({
        lock: true,
        text: "拼命上传中",
        spinner: "el-icon-loading",
        // background: 'rgba(0, 0, 0, 0.7)'
        background: "rgb(255, 255, 255, 0.5)",
        zIndex: "20004!important",
      });
      if (event.percent != 100) {


        this.$nextTick(() => {
          let loadingNode = document.getElementsByClassName("el-loading-mask");
          console.log(loadingNode);
          for (let i = 0; i < loadingNode.length; i++) {
            loadingNode[i].style.zIndex = 20006;
          }
        });
      } else if (event.percent == 100) {
        loading.close();
      }
    },

    // 文件上传成功时的钩子_调用本地新增
    onSuccess(response, file, fileList) {
      console.log(response, file, fileList);
      if (fileList[0].status == "success") {
       this.$refs.upload.submit();
        console.log("上传服务器成功");
        this.$refs.upload.clearFiles();
        var date = new Date()
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        let data = {
          //文件名
          orderFileName: this.posterURL.name,
          //服务器物理路径
          orderFileDir:
              this.obsFileDir +
              "/" +
              year + month +
              "/" +
              this.filename +
              "/" +
              this.posterURL.name,
          //图片展示路径
          orderFilePath:
              this.obsFileDir +
              "/" +
              year + month +
              "/" +
              this.filename +
              "/" +
              this.posterURL.name,
          orderFileStruts: 1,
          //订单ID
          orderId: this.orderInfo.id,
        };
        console.log(data);
        //新增
        this.$http.post("/orderfileinfo", data).then((res) => {
          console.log("新增数据", res);
          if (res.data.code == 200) {
            this.$message({
              message: "文件上传成功",
              type: "success",
            });
            //获取文件列表分页
            this.getUpLoadFilesList();
            //获取订单列表
            this.init(this.checked);
          }
        });
      }
    },

    //覆盖默认的上传行为，可以自定义上传的实现
    customUpload(file) {

      // if(this.fileData.length > 0){
      //   this.delFile(this.fileData[0],'2') // 先删除文件
      // }
      //在新增
      const loading = this.$loading({
        lock: true,
        text: '正在上传文件,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      obsClient = new ObsClient({
        access_key_id: this.obsAccessKeyId,
        secret_access_key: this.obsSecretAccessKey,
        server: this.obsServer,
      });
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      this.filename = Date.now(); //1603009495724,精确到毫秒，实际上是new Date().getTime()

      // this.posterURL = file.raw; // 获取URL

      var cp;
      var hook;
      obsClient.uploadFile(
          {
            Bucket: this.obsBucketName,
            // Key : this.obsFileDir,
            Key:
                this.obsFileDir +
                "/" +
                year + month +
                "/" +
                this.filename +
                "/" +
                this.posterURL.name,

            SourceFile: this.posterURL,
            PartSize: 3 * 1024 * 1024,
            //获取上传进度的回调函数。
            ProgressCallback: function (
                transferredAmount,
                totalAmount,
                totalSeconds
            ) {
              console.log((transferredAmount * 1.0) / totalSeconds / 1024);
              console.log(
                  "进度" + (transferredAmount * 100.0) / totalAmount + "%"
              );
              //上传进度
              let num = (transferredAmount * 100.0) / totalAmount; //百分比
              file.onProgress({ percent: num }); //进度条
              // if(hook && (transferredAmount / totalAmount) > 0.5){
              //   // 暂停断点续传任务
              //   hook.cancel();
              // }
            },
            //获取上传事件的回调函数。
            EventCallback: function (eventType, eventParam, eventResult) {
              // 处理事件响应
            },
            //获取断点续传控制参数的回调函数。
            ResumeCallback: function (resumeHook, uploadCheckpoint) {
              // 获取取消断点续传上传任务控制参数
              hook = resumeHook;
              // 记录断点
              cp = uploadCheckpoint;
            },
          },
          function (err, result) {
            // console.error("Error-->" + err);
            // 出现错误，再次调用断点续传接口，继续上传任务
            if (err) {
              obsClient.uploadFile(
                  {
                    //断点续传记录对象，可通过ResumeCallback回调函数获取到。
                    UploadCheckpoint: cp,
                    //获取上传进度的回调函数。
                    ProgressCallback: function (
                        transferredAmount,
                        totalAmount,
                        totalSeconds
                    ) {
                      console.log((transferredAmount * 1.0) / totalSeconds / 1024);
                      console.log(
                          "进度" + (transferredAmount * 100.0) / totalAmount + "%"
                      );
                      //上传进度
                      let num = (transferredAmount * 100.0) / totalAmount; //百分比
                      file.onProgress({ percent: num }); //进度条
                    },
                    //获取上传事件的回调函数。
                    EventCallback: function (eventType, eventParam, eventResult) {
                      // 处理事件响应
                    },
                  },
                  function (err, result) {
                    if (err) {
                      console.error("Error-->" + err);
                    } else {
                      if (result.CommonMsg.Status < 300) {
                        console.log(
                            "RequestId-->" + result.InterfaceResult.RequestId
                        );
                        console.log("Bucket-->" + result.InterfaceResult.Bucket);
                        console.log("Key-->" + result.InterfaceResult.Key);
                        console.log(
                            "Location-->" + result.InterfaceResult.Location
                        );
                      } else {
                        console.log("Code-->" + result.CommonMsg.Code);
                        console.log("Message-->" + result.CommonMsg.Message);
                      }
                    }
                  }
              );
            } else {
              console.log("Status-->" + result.CommonMsg.Status);

              //上传成功
              if (result.CommonMsg.Status == 200) {
                console.log("1111");
                console.log("2222");
                file.onSuccess(); //上传成功(打钩的小图标)
                this.$refs.upload.submit();
                this.$refs.upload.clearFiles();
              }
              if (result.CommonMsg.Status < 300 && result.InterfaceResult) {
                console.log("RequestId-->" + result.InterfaceResult.RequestId);
              }
            }
          })
      loading.close()


    },
    initOBS(){
      this.$http.get("/orderfileinfo/getBaseInfo").then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          //key   初始化使用
          this.obsAccessKeyId = res.data.data.obsAccessKeyId;
          //桶名称
          this.obsBucketName = res.data.data.obsBucketName;
          //文件夹
          this.obsFileDir = res.data.data.obsFileDir;
          //秘钥   初始化使用
          this.obsSecretAccessKey = res.data.data.obsSecretAccessKey;
          //服务器地址  初始化使用
          this.obsServer = res.data.data.obsServer;
        }
      })
    },
    //文件上传所需内容_上传到服务器
    submitUpload() {
      // this.customUpload(file)
      console.log(this.fileList);
      if (this.fileList.length == 0) {
        this.$message({
          message: "请选择文件进行上传",
          type: "warning",
        });
      }
      console.log(this.orderInfo.userfatherid);
      this.$refs.upload.submit();
    },

    // 上传文件
    upLoad() {
      let data = {
        date: "2021-06-03",
        name: "dafd.png",
        type: "1",
      };
      this.fileData.push(data);
    },
    fileApprove(item){
      if(item.customClassType === '授信客户' && (Number(item.financeBalance) < Number(item.discountfee))){
        this.$message.error("客户剩余信用额度不足以支付订单,请联系管理员增加授信！");
        return;
      }
      this.approveForm.orderId = item.id;
      this.approveForm.reviewOpinions = "";
      this.approveForm.unit = "";
      this.approveForm.fileStatus = "1";
      api
          .getOrderTime(item.id)
          .then((res) => {
            if (res.success) {
              this.approveForm.completionTime = res.data.day;
              this.lastUserBalance = res.data.lastUserBalance;
              this.financeTotalMoney = res.data.financeTotalMoney;
              this.orderFee = res.data.orderFee;
            }}
          )
      this.dialogVisibleFile = true;
    },
    approve(){
      if(this.approveForm.unit == ''){
        this.$message.warning("请选择外协单位");
        return;
      }
      if(this.approveForm.completionTime === "" ){
        this.$message.warning("请填写交付日期");
        return;
      }
      this.approveForm.fileReviewer =  JSON.parse(window.sessionStorage.getItem("currentInfo")).name;
      this.$confirm(`确定该操作吗?`)
          .then(() => {
            api
                .doApprove(this.approveForm)
                .then((res) => {
                  if (res.success) {
                    this.$message.success("审核成功");
                    this.init(this.checked);
                    this.dialogVisibleFile  = false;

                    } else {
                      this.$message.error("审核失败");
                    }
                })
                .catch((error) => {
                  console.error("error", error);
                });
          })
          .catch(() => {

          });

    },
    payApprove(item){
      this.$confirm(`确定该笔对公转账金额已到账操作吗?`)
          .then(() => {
            api
                .doPayApprove(item.id)
                .then((res) => {
                  if (res.success) {
                    this.$message.success("确认成功");
                    this.init(this.checked);
                  } else {
                    this.$message.error("确认失败");
                  }
                })
                .catch((error) => {
                  console.error("error", error);
                });
          })
          .catch(() => {

          });
    },
    // 打开上传文件
    upLoadFile(item) {
      this.dialogVisible = true;
      console.log(item);
      if (item.status == 11) {
        document.getElementById("upload-demo").style.display = "none"; //先导航到要改的标签
      }
      this.orderInfo = item;

      //获取文件列表分页
      this.getUpLoadFilesList();


    },

    logistics(item) {
      this.logisticsdialogVisible = true
      let data = {
        "language": "0",
        "trackingType": "1",
        "trackingNumber": [
          item.expressTrackingNumber
      ],
        "methodType": "1",
        "checkPhoneNo": item.contacttel.substring(item.contacttel.length -4,item.contacttel.length)
      }
      apiWab
          .querySfOrder(data).then((res) => {
           if(res.apiResultCode ==='A1000' &&  JSON.parse(res.apiResultData).errorCode ==='S0000') {
              this.routes = JSON.parse(res.apiResultData).msgData.routeResps[0].routes
            }
      });
    },

    // 获取文件列表分页
    getUpLoadFilesList() {
      this.$http
        .get(
          "/orderfileinfo?pageSize=" +
            this.pageSizefile +
            "&pageNumber=" +
            this.currentPagefile +
            "&orderId=" +
            this.orderInfo.id +
            "&startTime=" +
            this.startTime1 +
            "&endTime=" +
            this.endTime1
        )
        .then((res) => {
          console.log("获取文件列表分页", res);
          console.log(res.data.data.list);
          this.fileData = res.data.data.list;
          this.filetotal = res.data.data.total;
        });
    },

    //文件查询
    queryList() {
      //获取文件列表分页
      this.getUpLoadFilesList();
    },

    //删除
    delFile(row,type) {

      var obsClient = new ObsClient({
        access_key_id: this.obsAccessKeyId,
        secret_access_key: this.obsSecretAccessKey,
        server: this.obsServer,
      });

      obsClient.deleteObject(
          {
            Bucket: this.obsBucketName,
            Key: row.orderFileDir,
          },
          function (err, result) {
            if (err) {
              console.log("Error-->" + err);
              this.$message({
                message:'刪除失敗,'+err,
                type: "error",
              });
              loading.close();
            } else {
              console.log("Status-->" + result.CommonMsg.Status);

            }
          })

      this.$http.delete(`/orderfileinfo/${row.id}`).then((res) => {
        console.log("删除", res);
        if (res.data.code == 200) {
          //获取订单列表
          //this.init(this.checked);
          //获取文件列表分页
           this.getUpLoadFilesList();
          } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },

    //浏览
    browse(row) {
      console.log(row);
      this.BrowseUrl = row.orderFilePath;
    },
    editMoney(item) {
      console.log(item);
      this.editMoneys = true;
      this.orderId = item.id;
      this.orderOldMoney = item.discountfee;
      this.money = item.discountfee;
    },
    editDetail(item){
      this.editQuoteDesc = true;
      this.orderId = item.id;
      this.quoteDesc = item.quoteDesc;
      this.custRemark = item.custRemark;
    },
    showHis(item){
      this.orderId = item.id;
      api
          .editPriceHis(this.orderId)
          .then((res) => {
                // console.log("修改用户信息", res);
                if (res.success) {
                  this.hisData = res.data
                }
              }
          )
      this.hisdialogVisible = true;
    },
    // 支付相关
    paySet(item) {
      this.radio = "2";
      console.log(item);
      this.orderInfo = item;
      this.orderMoney = Number(item.discountfee);
      this.orderPay = this.orderMoney;
      this.disabled1 = this.disabled2 = this.disabled3 = false;
      this.getUserInfo(item.id);

      this.payPop = true;
      // this.payData();
    },
    // 订单详情
    details(item) {
      this.timer = new Date().getTime();
      this.orderInfo = item;
      // let level = "";
      // this.$nextTick(() => {
      //   level = this.$refs.orderDetails.returnLevel();
      //   console.log("获取会员级别", level);
      // });
      this.title = `订单【${this.orderInfo.id}】详情`;
      this.detail = true;
    },
    feeDetails(item){
      this.timer = new Date().getTime();
      this.orderInfo = item;
      this.title = `订单【${item.id}】报价明细`;
      this.feedetail = true;

    },
    //投诉
    complaint(item) {
      console.log(item);
      this.complaints = true;
      this.complaintsList = item;
    },

    //投诉分类
    CheckedChange(value) {
      console.log(value);
    },

    //立即投诉
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          console.log(this.form);
          let array = "";
          for (let a = 0; a < this.form.types.length; a++) {
            array = array + this.form.types[a].id + ",";
          }
          // 去掉最后一个逗号
          if (array.length != 0) {
            array = array.substring(0, array.length - 1);
          }
          console.log(array);

          let userInfo = JSON.parse(
            window.sessionStorage.getItem("currentInfo")
          );
          console.log(userInfo);
          let datas = new FormData();
          //订单ID
          datas.append("orderNumber", this.complaintsList.id);
          //用户ID
          datas.append("userId", userInfo.user_ID);
          //投诉类型
          datas.append("complaintsType", array);
          //投诉内容
          datas.append("complaintsContext", this.form.text);
          //投诉内容
          // datas.append("orderImprove", this.form.text);

          console.log(datas);
          this.$http.post("/ordercomplaints", datas).then((res) => {
            console.log("投诉", res);
            if (res.data.code == 200) {
              this.$message({
                message: "投诉成功",
                type: "success",
              });
              this.complaints = false;
              this.init(this.checked);
              this.$emit("jumpNav");
            } else {
              this.$message.error("投诉失败");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //投诉重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //富文本内容变化
    change(val) {
      console.log(val);
    },
    tableRowClassName({ row, rowIndex }) {
      // if(row.fileStatus == 0 &&  row.deleted ==0){
      //   return `status-danger`;
      // }
      // else  if(row.fileStatus == 2 || row.deleted ==1){
      //   return `status-error`;
      // }

    },
    // 表格自定义样式调整
    tableRowStyle() {
      return "padding:0;";
    },
    exportData(){
      window.location.href = url.baseUrl + '/orderinfo/orderInfoList/export?startTime='+this.starttime+'&endTime='+this.endtime+'&customerid='+this.orderUserId+'&pageSize='+this.pageSize+'&pageNumber='+this.currentPage+'&userid='+this.customerID+'&payStruts='+this.orderPayType+'&productType='+this.productType+'&id='+this.orderId+'&productName='+this.productName+'&deleted='+this.deleted+'&customClassType='+this.customClassType+'&orderName='+this.orderName+'&fileStatus='+this.fileStatus;
    },
    //获取订单列表
    init(checked) {
      this.checked = checked;
      api
        .queryOrder(
          this.starttime,
          this.endtime,
          this.customerID,
          this.pageSize,
          this.currentPage,
          this.orderUserId,
          this.orderPayType,
          this.orderId,
          this.productType,
         this.productName,
            this.deleted,
            this.customClassType,
            this.orderName,
            this.fileStatus
        )
        .then((res) => {
          console.log("获取订单列表", res);
          if (res.success) {
            this.total = res.data.pageInfo.total;
            let data = res.data.pageInfo.list;
            // data.forEach((el) => {
            //   if (el.whetherFullPayment === 1) {
            //     el.surplusMoney = (Number(el.discountfee) * 0.7).toFixed(2);
            //   }
            // });
            // let mapList = data.map(el=>{

            // })
            this.tableData = data;
            //this.allTotalMoney = Number(res.data.resultMoney).toFixed(2);
          } else {
            this.$message.error("获取订单列表失败");
          }
        })
        .catch((error) => {
          console.error("error", error);
        });
    },

    // 进度追踪
    track(item) {
      console.log(item);
      this.speed = true;
      api.oplogger(item.id).then((res) => {
        console.log("订单流程图", res);
        if (res.success) {
          if (res.data.length > 0) {
            res.data.forEach((el) => {
              el.color = "#0bbd87";
            });
          }
          this.activities = res.data;
        } else {
          this.$message.error("获取订单流程失败");
        }
      });
    },
    // 发票申请
    applyInvoice() {
      // console.log(item);
      // this.orderInfo = item;
      if (this.userType !== 0) {
        this.$message.warning("当前账号非客户账号,无法申请开发票！");
        return;
      }
      // api.getinvoiceList(this.userId).then((res) => {
      //   console.log("获取发票列表", res);
      //   if (res.success) {
      //     if (res.data.length > 0) {
      //       if (this.selectList.length <= 0) {
      //         this.$message.warning(
      //           "请选择当前分页可开票订单！(未开票且已支付的订单)"
      //         );
      //         return;
      //       }
      //       console.log(res.data[0]);
      //       this.billdInfo = res.data[0];
      //       this.billing = true;
      //     } else {
      //       this.$confirm(
      //         "当前账号尚未填写发票信息，请前往费用中心填写发票资料！",
      //         "发票信息完善",
      //         {
      //           confirmButtonText: "确定",
      //           cancelButtonText: "取消",
      //           type: "warning",
      //         }
      //       )
      //         .then(() => {})
      //         .catch(() => {});
      //     }
      //   }
      // });
    },
    // 切换列表
    replace(item) {
      this.checked = item.id;
      console.log(item);
      if (item.id === 1) {
        this.init(1);
      }
      // if (item.id === 1) {
      //   this.getInvoice();
      // } else {
      //   this.init();
      // }
    },
    batchPay(){
      let deletedList = this.selectList.filter(item =>  item.deleted == 1)
      if(deletedList.length > 0){
        this.$message.warning("不能选择已取消的订单!" );
        return;
      }
      let nopayList =   this.selectList.filter(item =>  item.payStruts == 5);
      if(nopayList.length > 0){
         this.$message.warning("请选择未支付的订单!" );
         return;
      }
      let payList = []
      this.selectList.forEach(item => {
         payList.push(item.id)
      });
      api.getBatchPayInfo(payList.join(",")).then((res) => {
        this.radio = "2";
         this.orderInfo = res.data;
        this.orderPay = Number(this.orderInfo.discountfee);
        this.disabled1 = this.disabled2 = this.disabled3 = false;
        this.getUserInfo(payList.join(","));
        this.batchPayPop = true;


      })
    },
    goToPay(){
      this.reload();
      window.sessionStorage.setItem("nav", '3');
      this.$store.dispatch("setNavBgd", 3);
      this.$router.push({ name: "Cost"});
    },
    onlinePay(){
      let deletedList = this.selectList.filter(item =>  item.deleted == 1)
      if(deletedList.length > 0){
        this.$message.warning("不能选择已取消的订单!" );
        return;
      }
      let nopayList =   this.selectList.filter(item =>  item.payStruts == 5);
      if(nopayList.length > 0){
        this.$message.warning("请选择未支付的订单!" );
        return;
      }
      let payList = []
      this.selectList.forEach(item => {
        payList.push(item.id)
      });

      if(payList.length == 0){
        this.$message.warning("请至少选择一个订单!" );
        return;
      }
      api.getBatchPayInfo(payList.join(",")).then((res) => {
        this.orderIds = payList.join(",")
        this.orderInfo = res.data;
        this.orderPay = Number(this.orderInfo.discountfee);
        this.showSuer = true;
        this.onlinePayPop = true;


      })
    },
    onlinePayAdmin(item){

      if(item.deleted == 1){
        this.$message.warning("不能选择已取消的订单!" );
        return;
      }

      if(item.payStruts == 5){
        this.$message.warning("请选择未支付的订单!" );
        return;
      }
       let payList = []
        payList.push(item.id)

      if(payList.length == 0){
        this.$message.warning("请至少选择一个订单!" );
        return;
      }
      api.getBatchPayInfo(payList.join(",")).then((res) => {
        this.orderIds = payList.join(",")
        this.orderInfo = res.data;
        this.orderPay = Number(this.orderInfo.discountfee);
        this.showSuer = true;
        this.onlinePayPop = true;


      })
    },

    // 查询
    query() {
      //   if (
      //     this.starttime === "" &&
      //     this.endtime === "" &&
      //     this.cpid === "" &&
      //     this.orderType === "" &&
      //     this.orderPayType === ""
      //   ) {
      //     this.$message.warning("请输入查询参数");
      //     return;
      //   }
      this.init(this.checked);
    },
    // 选择客户分页
    handleSizeChange4(val) {
      this.pageSize3 = val;
      this.getCustomer();
    },
    handleCurrentChange4(val) {
      this.pageNumber3 = val;
      this.getCustomer();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.init(this.checked);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.init(this.checked);
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.getInvoice();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.getInvoice();
    },
    handleSizefileChange(val) {
      this.pageSizefile = val;
      this.getUpLoadFilesList();
    },
    handleCurrentfileChange(val) {
      this.currentPagefile = val;
      this.getUpLoadFilesList();
    },
    //tabbar切换
    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.index);
      this.index = tab.index;
    },
  },

  // mounted() {
  //     this.$nextTick(() => {
  //         let loadingNode = document.getElementsByClassName('el-loading-mask')
  //         console.log(loadingNode)
  //         for (let i = 0; i < loadingNode.length; i++) {
  //             loadingNode[i].style.zIndex = 20006
  //         }
  //     })
  // },
};
</script>

<style lang="scss" scoped>
.personalInfo {
  padding: 20px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;

  .card-left {
    width: 200px;
    height: 320px;

    .top {
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: #047bd7;
      color: #fff;
      font-size: 24px;

      i {
        font-size: 28px;
        margin-right: 10px;
      }
    }

    .infos {
      width: 100%;
      box-sizing: border-box;
      // border: 1px solid #e6e6e6;
      // border-top: none;
      li {
        box-sizing: border-box;
        width: 100%;
        height: 55px;
        text-align: center;
        line-height: 55px;
        border-bottom: 1px dashed #e6e6e6;
        cursor: pointer;
      }

      li:last-child {
        border-bottom: none;
      }

      .checked {
        background-color: #058af2;
        color: #fff;
        font-weight: 600;
      }
    }
  }

  .card-right {
    width: 1500px;
    background-color: #fff;
  }

  .info {
    width: 100%;
    box-sizing: border-box;
    // padding: 15px;
  }

  .card {
    width: 100%;

    .screen {
      margin-top: 10px;

      .colls {
        display: flex;
        line-height: 40px;
       margin-left: 5px;
        span {
          margin-right: 5px;
          width: 100px;
        }

        .kuoz {
          margin: 0 10px;
        }
      }
      .moneyTotal {
        line-height: 40px;
       // margin-top: 15px;
      }

      .coll {
        display: flex;
        justify-content: space-around;
        .ipt {
          width: 25%;
        }
      }
      .btn {
        margin-left: 20px;
      }
    }

    .card-top {
      display: flex;
      align-items: center;
      height: 50px;
      border-bottom: 1px solid #e6e6e6;
      padding: 0 30px;
      line-height: 50px;

      span {
        display: inline-block;
        width: 5px;
        height: 17px;
        background: #058af2;
        margin-right: 20px;
      }

      h3 {
        color: #058af2;
      }
    }

    .list {
      width: 100%;
      box-sizing: border-box;
      padding: 5px 30px;

      .list-top {
        display: flex;
        justify-content: space-between;

        span {
          color: #058af2;
        }

        span:last-child:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }

      .list-item {
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .items {
          margin-top: 10px;
          width: 255px;
          height: 155px;
          background: transparent url("../../static/imgs/beijing1.png")
            no-repeat scroll 0% 0%;
          position: relative;

          .border {
            box-sizing: border-box;
            padding: 15px;
            font-size: 14px;
            font-weight: 400;

            p {
              padding: 3px 0 5px 0;

              border-bottom: 1px solid #e6e6e6;
            }

            i {
              display: inline-block;
              margin-right: 10px;
            }

            p:nth-child(2) {
              height: 65px;
              display: flex;
              align-items: center;

              span {
                display: block;
                overflow: hidden;
                white-space: normal;
                text-overflow: ellipsis;
              }
            }

            p:last-child {
              border-bottom: none;
            }
          }

          .top {
            position: absolute;
            top: 0;
            right: 15px;
            font-size: 14px;
            height: 20px;
            line-height: 20px;
            color: #fff;

            .top-df {
              display: none;
              background: #fbb244 none repeat scroll 0% 0%;
              padding: 0px 10px;
              border-radius: 0px 0px 5px 5px;
            }
          }

          .active {
            display: block;
            padding: 0 10px;
            background: #058af2 none repeat scroll 0% 0%;
          }

          .top:hover {
            cursor: pointer;
            text-decoration: underline;
          }

          .bottom {
            display: none;
            position: absolute;
            right: 20px;
            bottom: 8px;
            cursor: pointer;
            font-size: 14px;

            p {
              float: left;
              border: 1px solid #d4d4d4;
              margin-left: 5px;
              height: 25px;
              line-height: 25px;
              width: 40px;
              text-align: center;
              border-radius: 3px;
              background-color: #fff;
            }

            p:hover {
              color: #058af2;
            }
          }
        }

        .items-bgd {
          background: transparent url("../../static/imgs/beijing2.png")
            no-repeat scroll 0% 0%;
        }

        .items:hover .top-df {
          display: block;
        }

        .items:hover .bottom {
          display: block;
        }

        .items:nth-last-child(-n + 1) {
          height: 0;
          background: none;
        }
      }
    }
  }

  /* 查询条件 */
  .query {
    margin: 10px 0;
    display: flex;
    align-items: center;

    .input {
      width: 30%;
      margin: 0 10px;
    }

    .btn {
      margin-left: 10px;
    }
  }

  /* 开票记录 */
  .invoices {
    .pages {
      margin: 10px;
    }
  }
  .invoiceListClass {
    padding: 10px;
  }

  /*账户充值*/
  .recharge {
    .card-form {
      width: 50%;
      margin: 30px auto;
      /*账户充值_金额数目*/
      .money {
        color: red;
        padding: 0 5px;
        font-weight: bold;
      }
    }

    /*付款方式*/
    .payment {
      width: 95%;
      border-top: 1px dashed #e6e6e6;

      .text {
        font-size: 14px;
        width: 50%;
        margin: 20px auto 20px;
      }

      /*付款平台*/
      .pingtai {
        overflow: hidden;

        ul li {
          float: left;
          display: inline;
          position: relative;
          width: 177px;
          height: 50px;
          cursor: pointer;
          border: 1px solid #d2d1d1;
          margin-right: 18px;
          /*微信支付*/
          .wx {
            background: url(../../static/imgs/sprites-payment-logo.png)
              no-repeat;
            background-position: 0 -1880px;
            display: inline-block;
            width: 175px;
            height: 37px;
            vertical-align: middle;
            position: absolute;
            top: 7px;
            *top: 5px;
            left: 1px;
            z-index: 2;
          }

          /*支付宝支付*/
          .zfb {
            background: url(../../static/imgs/sprites-payment-logo.png)
              no-repeat;
            background-position: 0 -120px;
            display: inline-block;
            width: 175px;
            height: 37px;
            vertical-align: middle;
            position: absolute;
            top: 7px;
            *top: 5px;
            left: 1px;
            z-index: 2;
          }
        }
      }
    }
  }

  /*上传文件*/
  .bill {
    /*筛选条件*/
    .card-form {
      display: flex;
      line-height: 40px;
      margin: 20px auto;
      margin-right: 20px;
      justify-content: flex-end;

      div {
        padding: 0 5px;
      }
    }

    /*表格*/
    .table {
      margin-right: 0;
      border-top: 1px dashed #e6e6e6;

      table {
        width: 100%;
        border-collapse: collapse; //去除td之间的空隙

        tr {
          th:first-of-type {
            width: 40%;
          }

          td {
            font-size: 13px;

            .grey {
              color: #b4b4b4;
              margin-right: 5px;
            }

            .bottom {
              height: 90px;
              padding-top: 10px;
            }

            .bottom > p {
              line-height: initial;
              margin: 5px 0;
            }

            /*图文部分*/
            .picture {
              display: flex;
              font-size: 13px;
              line-height: initial;

              img {
                margin-left: 15px;
                margin-bottom: 10px;
                width: 80px;
                height: 80px;
              }

              .text {
                margin-left: 15px;
                margin-top: 0;
                margin-bottom: 0;
                display: grid;

                p {
                  color: #999;

                  a {
                    color: #1d94d1;
                    text-decoration: none;
                  }

                  .c1 {
                    color: #e56315;
                  }
                }
              }
            }
          }

          /*订单状态/进度追踪*/
          .zhuangtai,
          .jindu {
            text-align: center;

            i {
              font-weight: bold;
            }
          }
        }

        .list {
          border: 1px solid #f8f8f8;

          td > div:first-of-type {
            background-color: #f8f8f8;
          }
        }
      }
    }

    /*分页*/
    .pages {
      display: flex;
      margin: 20px 20px;
      justify-content: space-between;
    }
  }

  /*发票申请*/
  /*.invoice{*/
  /*    !*.card-top{*!*/
  /*        a{*/
  /*            font-size: 14px;*/
  /*            color: #1D94D1;*/
  /*            cursor: pointer;*/
  /*            text-decoration: none;*/
  /*        }*/
  /*    !*}*!*/
  /*}*/
}
.dialogs {
  width: 100%;
  .queryMember {
    width: 100%;
    margin-bottom: 10px;
  }
  .memberTable {
    ::v-deep .el-radio__label {
      display: none;
    }
  }
}
.tables {
  ::v-deep .el-table .cell {
    padding: 0;
  }

  ::v-deep .el-table .cell,
  ::v-deep .el-table--border td:first-child .cell {
    padding: 0;
  }

  ::v-deep .el-table_1_column_1 {
    padding: 0;
  }

  ::v-deep .el-table td {
    padding: 0;
  }

  .top {
    width: 100%;
    height: 28px;
    line-height: 28px;
    text-align: center;
     background-color: #f8f8f8;
    color: #b4b4b4;

    span {
      color: #000000;
    }
  }

  .box {
    padding: 5px 10px;
   //  height: 145px;
    display: flex;
    justify-content: space-around;
    .img {
      margin: 4px 15px 0;
      width: 80px;
      height: 80px;

      img {
        display: inline-block;
        width: 80px;
        height: 100%;
      }
    }
    .info {
      width: 35%;
      .p1 {
        color: #409eff;
       max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        vertical-align: middle;
      }

      .p3 {
        span {
          color: #ff0000;
        }
      }
    }
    .rights {
      width: 35%;
      .p3 {
        span {
          color: #ff0000;
        }
      }
    }
  }

  .types {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      padding: 10px 0;
    }

    .btn {
      width: 50%;
    }
  }

  .boxInfo {
    display: flex;
    justify-content: center;
    align-items: center;

    ::v-deep .el-button {
      height: 40px;
    }
  }
}

.content {
  .orderInfo {
    margin-bottom: 10px;

    p {
      text-indent: 2em;
    }
  }
}

.upFile {
  text-align: center;

  .top {
    margin-bottom: 10px;

    .date {
      margin-top: 10px;

      .btn {
        margin-left: 10px;
      }
    }
  }

  .tableList {
    margin-bottom: 10px;

    .success {
      color: #058af2;
    }

    .error {
      color: #ff0000;
    }
  }

  .noTable {
    text-align: center;
    color: #66b1ff;
    margin: 15px;
  }

  .upBtn {
    margin-top: 15px;
  }
}

.payContent {
  /*text-align: center;*/

  .orderInfo {
    margin: 10px 0;
  }

  .top {
    margin: 10px 0;

    .check-group {
      display: flex;
      flex-direction: column;
      line-height: 30px;
    }
  }

  .ipt {
    height: 40px;
    line-height: 40px;
    display: flex;
    margin: 15px 0px;

    .inputs {
      width: 200px;
    }
  }

  .payTypes {
    /*付款平台*/
    .pingtai {
      display: flex;
      justify-content: center;
      align-items: center;

      ul li {
        float: left;
        display: inline;
        position: relative;
        width: 177px;
        height: 50px;
        cursor: pointer;
        border: 1px solid #d2d1d1;
        margin-right: 18px;
        /*微信支付*/
        .wx {
          background: url(../../static/imgs/sprites-payment-logo.png) no-repeat;
          background-position: 0 -1880px;
          display: inline-block;
          width: 175px;
          height: 37px;
          vertical-align: middle;
          position: absolute;
          top: 7px;
          *top: 5px;
          left: 1px;
          z-index: 2;
        }

        /*支付宝支付*/
        .zfb {
          background: url(../../static/imgs/sprites-payment-logo.png) no-repeat;
          background-position: 0 -120px;
          display: inline-block;
          width: 175px;
          height: 37px;
          vertical-align: middle;
          position: absolute;
          top: 7px;
          *top: 5px;
          left: 1px;
          z-index: 2;
        }
      }
    }

    .imgs {
      display: flex;
      justify-content: center;
    }

    p {
      text-align: center;
      color: #ff0000;
    }
  }

  .successBtn {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

/*投诉 表格*/
.complaints {
  table {
    border: 1px solid #ebeef5;
    width: 100%;
    /*tr{*/
    /*    border-bottom: 1px solid #EBEEF5;*/
    /*}*/
    /*tr:last-of-type{*/
    /*    border-bottom: 0;*/
    /*}*/
    tr {
      th {
        color: #909399;
        font-size: 14px;
        font-weight: bold;
        padding: 12px 10px;
        text-align: center;
        border-right: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
      }

      th:last-of-type {
        border-right: 0;
      }

      td {
        color: #606266;
        font-size: 14px;
        padding: 12px 10px;
        text-align: center;
        border-right: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
      }

      td:last-of-type {
        border-right: 0;
      }

      .orange {
        color: #eb6d00;
        font-size: 20px;
      }
    }

    tr:last-of-type th {
      border-bottom: 0;
    }

    tr:last-of-type td {
      border-bottom: 0;
    }
  }
}

/*文件上传弹框*/
.file {
  ::v-deep .el-dialog {
    overflow: auto;
    //height: 700px;
  }
}

/*操作_浏览按钮*/
.browse {
  padding: 0;

  .liulan {
    color: white;
    text-decoration: none;
    height: 100%;
    padding: 7px 15px;
    display: block;
    text-align: center;
  }
}


</style>

<style lang="scss">
 .status-danger {
  background-color: #fef0f0!important;
}
 .status-error {
   background-color: #ffbaba!important;
 }
.el-checkbox__inner,
.el-radio__inner {
  border: 1px solid #232430;
}
/*tabbar切换  */
.el-tabs {
  display: block;
  width: 100%;
  /*tabbar分布*/
  .el-tabs__nav {
    width: 100%;
    display: flex;
    justify-content: space-around;

    .el-tabs__active-bar {
      display: none;
    }

    .is-active {
      border-bottom: 2px solid #409eff;
    }

    .el-tabs__item {
      margin: 0 20px;
      padding: 0;
    }
  }
}

.table {
  .list {
    .bottom {
      /*上传文件按钮*/
      .el-button--text {
        color: white;
        border-radius: 5px;
        padding: 12px 15px;
        background-color: #409eff;
      }
    }

    .jindu {
      /*进度追踪按钮*/
      .el-button--text {
        color: white;
        border-radius: 5px;
        padding: 10px 8px;
        background-color: #409eff;
      }
    }
  }
}

.el-input__icon:after {
  height: auto;
}

/*  !*表格样式  *!*/
/*    .table {*/
/*        .el-table .cell {*/
/*            text-align: center !important;*/
/*        }*/
/*    }*/

/*!*  发票申请（按钮样式）  *!*/
/*  .invoice{*/
/*      .el-row{*/
/*          display: flex;*/
/*          margin: 10% auto;*/
/*          button{*/
/*              margin: auto;*/
/*          }*/
/*      }*/

/*  !*  申请发票表单  *!*/
/*      .el-form{*/
/*          margin: 20px auto;*/
/*          width: 50%;*/
/*      }*/
/*  }*/

.card {
  .detail {
    .el-dialog {
      height: 75% !important;
      overflow: auto;

      .el-dialog__header {
        padding: 20px 20px 20px;
        // position: fixed;
        background: #fff;
        width: calc(55% - 40px);
      }

      // .el-dialog__body {
      //   margin-top: 64px;
      // }
    }
  }
}
</style>
